const leaflets = {
  "pam": {
    "config": {
      "primary-color": "rgb(0, 135, 60)",
      "secondary-color": "rgb(0, 164, 100)",
      "tertiary-color": "#ffdd00",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
      "clientIcon": require("assets/images/logo-Pam.png"),
      "serverPath": "pam.supercentro.interattivo.net/",
      "pdfPath": "/media/pdf/volantino.pdf",
      "shareFlyerTitle": "Dai uno sguardo al nuovo volantino interattivo di PAM SUperstore!",
      "shareFlyerURL": "https://pam.supercentro.interattivo.net?v=277",
      "shareProductSentence": "Guarda il Volantino di PAM!",
      "ogTitleMeta": "PAM | Volantino interattivo",
      "ogDescriptionMeta": "Dai uno sguardo al volantino interattivo di PAM. Offerte valide dal 14/12 al 27/12",
      "ogImageMeta": "https://pam.supercentro.interattivo.net/media/images/pam_fb_7129.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": true,
      "ga_tracking_id": "UA-152069090-40",
      "release_id": "3",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 20,
      "client_id": 31,
      "signboard_id": 50,
      "has_pages": true,
      "hide_grocery_list": false,
      "hide_searchbar": false,
      "hide_listPages": false,
      "line_through": false,
      "category_banner": "",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false
    },
    "leaflet": {
      "name": "7129 PAM",
      "code": "277",
      "id_campaign": "277",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/Indice-7129-PAM_sbASADH_2FELI4u.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 25.464349134373048,
              "left": 11.962278670763808,
              "width": 77.3143962300841,
              "height": 5.58034364414722
            }
          },
          {
            "page": 5,
            "blueprint": {
              "top": 31.147483689742526,
              "left": 11.901978073287056,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 7,
            "blueprint": {
              "top": 37.50373761629305,
              "left": 11.836442075099145,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 10,
            "blueprint": {
              "top": 44.04722890469312,
              "left": 11.726752416831914,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 12,
            "blueprint": {
              "top": 50.21217796943381,
              "left": 11.901029824688862,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 14,
            "blueprint": {
              "top": 56.4417491267718,
              "left": 11.599493448269962,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 16,
            "blueprint": {
              "top": 62.85854691376945,
              "left": 12.015948205860225,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 17,
            "blueprint": {
              "top": 69.34505385136225,
              "left": 11.898659203193375,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": 19,
            "blueprint": {
              "top": 75.6280426950744,
              "left": 11.32502222374179,
              "width": 77.3143962300841,
              "height": 6.295186192141955
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://volantinointerattivo.net",
            "target": "_blank",
            "blueprint": {
              "top": 5.099667774086379,
              "left": 63.47093023255814,
              "width": 27.999999999999993,
              "height": 8.041943521594682
            }
          }
        ]
      },
      "categories": [
        {
          "category_name": "Bevande",
          "subcategories": [
            "Vini e Spumanti",
            "Liquori",
            "Bibite",
            "Birre",
            "Acqua",
            "Succhi"
          ]
        },
        {
          "category_name": "Alimentari",
          "subcategories": [
            "Dispensa",
            "Snack Salati",
            "Snack Dolci",
            "Rossi",
            "Olio",
            "Pasta",
            "Colazione"
          ]
        },
        {
          "category_name": "Gastronomia",
          "subcategories": [
            "Salumi",
            "Formaggi",
            "Piatti Pronti",
            "Panetteria"
          ]
        },
        {
          "category_name": "Self Service",
          "subcategories": [
            "Ittico",
            "Formaggi",
            "Vegetali",
            "Pasta",
            "Salumi",
            "Yogurt",
            "Snack",
            "Latte"
          ]
        },
        {
          "category_name": "Surgelati",
          "subcategories": [
            "Ittico",
            "Verdure",
            "Panati",
            "Gelati",
            "Dolci"
          ]
        },
        {
          "category_name": "Macelleria",
          "subcategories": [
            "Avicoli",
            "Bovino",
            "Altro",
            "Suino"
          ]
        },
        {
          "category_name": "Ortofrutta",
          "subcategories": [
            "Verdura",
            "Frutta"
          ]
        },
        {
          "category_name": "Piccoli elettrodomestici",
          "subcategories": [
            "Preparazione cibo"
          ]
        },
        {
          "category_name": "Casa e Cucina",
          "subcategories": [
            "Altro",
            "Stoviglie"
          ]
        },
        {
          "category_name": "Igiene Casa",
          "subcategories": [
            "Stoviglie",
            "Bucato",
            "Superfici"
          ]
        },
        {
          "category_name": "No Food",
          "subcategories": [
            "Home"
          ]
        },
        {
          "category_name": "Igiene Persona",
          "subcategories": [
            "Corpo",
            "Viso",
            "Capelli",
            "Orale",
            "Intima"
          ]
        }
      ],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0001_BhRmEEQ.jpg",
          "products": [
            {
              "item_id": "166815",
              "field1": "martini ",
              "field2": "spumante asti docg ",
              "field3": "cl. 75",
              "field4": "",
              "description": "martini  spumante asti docg  cl. 75",
              "grammage": 750,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 0.0,
                "left": 34.73873873873874,
                "width": 24.576576576576574,
                "height": 49.69111969111969
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Martini_Asti_spumante_cl.75_1604476419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_0JQntxO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "237688",
              "field1": "le cadeau",
              "field2": "valigetta gioiello",
              "field3": "",
              "field4": "",
              "description": "le cadeau valigetta gioiello",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 0.0,
                "left": 59.315315315315324,
                "width": 40.68468468468467,
                "height": 49.69111969111969
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3263873_Le_cadeau_strenna_GIOIELLO_PANDORO_6PZ_1604475555.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_u3e4kO1_lfzRK7Q.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "",
                  "data": {
                    "specifiche": "bauli pandoro cellophane gr. 500, baratti & milano cioccolato bianco con champagne e ribes nero di gr. 75, sperlari confezione morbidelli gr. 90, sperlari sacchetto morbide gelatine alla frutta gr. 100, fiore confezione cantucci al cioccolato gr. 100, la sassellese confezione canestrelli gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "166083",
              "field1": "bauli panettone di verona zero canditi 1 Kg",
              "field2": "Balocco panettone classico 1 Kg",
              "field3": "Maina Il gran pandoro classico 1 Kg",
              "field4": "",
              "description": "bauli panettone di verona zero canditi 1 Kg Balocco panettone classico 1 Kg Maina Il gran pandoro classico 1 Kg",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "bauli panettone di verona zero canditi 1Kg",
                "Balocco panettone classico 1 Kg",
                "Maina Il gran pandoro classico 1 Kg"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 49.69111969111969,
                "left": 34.72072072072072,
                "width": 65.27927927927927,
                "height": 45.965250965250966
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8001720021209__PANETTONE_DI_VERONA_1000G_H_1573487608.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1_7I9lBys.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/2_pUKr1ek.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Mt3xncU_DkT1wf0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/video/Spot_2018_Pandoro_Maina.mp4"
                }
              ]
            },
            {
              "item_id": "132556",
              "field1": "rovagnati ",
              "field2": "prosciutto cotto gran biscotto ",
              "field3": "l'etto",
              "field4": "",
              "description": "rovagnati  prosciutto cotto gran biscotto  l'etto",
              "grammage": 100,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 50.91698841698841,
                "left": 3.288288288288288,
                "width": 30.270270270270267,
                "height": 36.67953667953668
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Granbiscotto_rovagnati_1520522013.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Gran-Biscotto-Arrosto_1574239326.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_O44XViC_TCvdl47.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "world",
                  "title": "",
                  "data": "https://www.rovagnati.it/it/prodotti/prosciutti-cotti/10/gran-biscotto-classico"
                }
              ]
            }
          ]
        },
        {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0002_iq8sKCF.jpg",
          "products": [
            {
              "item_id": "197283",
              "field1": "motta",
              "field2": "panettone gran cremoso",
              "field3": "gr. 800",
              "field4": "-caramello -panna e cioccolato",
              "description": "motta panettone gran cremoso gr. 800 -caramello -panna e cioccolato",
              "grammage": 800,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Caramello",
                "Panna e cioccolato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 7.866795366795366,
                "left": 4.0990990990990985,
                "width": 30.270270270270267,
                "height": 36.67953667953668
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8034097875274_GRANCREMOSO_PANETTONE_AL_CARAMELLO_800G_H_1605718143.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8034097875298_GRANCREMOSO_PANETTONE_PANNA_E_CIOCCOLATO_800G_H_1605718159.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_IifoYB5_0yGdqX9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165807",
              "field1": "bauli",
              "field2": "il budino",
              "field3": "gr. 750",
              "field4": "",
              "description": "bauli il budino gr. 750",
              "grammage": 750,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 7.866795366795366,
                "left": 34.369369369369366,
                "width": 15.810810810810809,
                "height": 36.67953667953668
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8001720312178__IL_BUDINO_750G_H_1573487624.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_kxCzkM1_tQ8JZKK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239399",
              "field1": "balocco",
              "field2": "pandoro",
              "field3": "cioco party",
              "field4": "gr. 800",
              "description": "balocco pandoro cioco party gr. 800",
              "grammage": 800,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 7.866795366795366,
                "left": 50.18018018018018,
                "width": 13.468468468468467,
                "height": 36.67953667953668
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Balocco_Ciokoparty_800g_1573644422_1605714251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_MxgTBgD_Y3zILrP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165808",
              "field1": "maina",
              "field2": "pandoro gr. 750 -bavarese -limon crema",
              "field3": "panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "field4": "",
              "description": "maina pandoro gr. 750 -bavarese -limon crema panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "grammage": 0,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bavarese",
                "Limone e crema"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 7.142857142857143,
                "left": 73.96396396396395,
                "width": 24.45945945945946,
                "height": 14.189189189189188
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3240740_MAINA_Crema_al_cioccolato_pnt_gr.800_1542108609.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3242086_MAINA_Crema_pasticcera_pnt_gr.800_1542108619.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/thumb_1573489741.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3234040_Il_Golosone_Limoncrema_2020_1605795730.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_wDXbXeD_hBqpqqw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165808",
              "field1": "maina",
              "field2": "pandoro gr. 750 -bavarese -limon crema",
              "field3": "panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "field4": "",
              "description": "maina pandoro gr. 750 -bavarese -limon crema panettone gr. 800 -crema al cioccolato -crema pasticcera",
              "grammage": 0,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Crema al cioccolato",
                "Crema pasticcera"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 25.868725868725868,
                "left": 63.78378378378379,
                "width": 24.45945945945946,
                "height": 14.189189189189188
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3240740_MAINA_Crema_al_cioccolato_pnt_gr.800_1542108609_riXSXky.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3242086_MAINA_Crema_pasticcera_pnt_gr.800_1542108619_tcovHek.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/thumb_1573489741_HL4BF36.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3234040_Il_Golosone_Limoncrema_2020_1605795730_1vt9HOR.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_F6WZ2zT_q2UQIuu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197288",
              "field1": "giovanni cova & c. ",
              "field2": "- pandoro classico incartato a mano ",
              "field3": "-panettone classico incartato a mano",
              "field4": "kg. 1",
              "description": "giovanni cova & c.  - pandoro classico incartato a mano  -panettone classico incartato a mano kg. 1",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pandoro classico",
                "Panettone classico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.88416988416988,
                "left": 4.054054054054054,
                "width": 46.53153153153153,
                "height": 17.664092664092664
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3259263_Cova_pandoro_incartato_kg.1_1605813534.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3261136_Cova_panettone_incartato_kg.1_1605813892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_xIoqyZV_KYJwhZI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "167085",
              "field1": "tre marie",
              "field2": "-panettone milanese classico/senza canditi kg. 1",
              "field3": "-pandoro il magnifico classico kg. 1",
              "field4": "",
              "description": "tre marie -panettone milanese classico/senza canditi kg. 1 -pandoro il magnifico classico kg. 1",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Panettone milanese classico",
                "Panettone milanese senza canditi",
                "Pandoro il magnifico classico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.88416988416988,
                "left": 50.585585585585584,
                "width": 47.88288288288288,
                "height": 17.664092664092664
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3231800_TRE_MARIE_Pandoro_Magnifico_KG.1_1573488419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/tre_marie_il_panettone_milanese_basso_750_gr_1573488484.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/tre_marie_il_panettone_milanese_senza_canditi_1_kg_1573488496.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_brsCYdP_ZzV2GDH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165809",
              "field1": "bauli",
              "field2": "pandoro con crema baileys",
              "field3": "gr. 750",
              "field4": "",
              "description": "bauli pandoro con crema baileys gr. 750",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 62.69305019305019,
                "left": 3.918918918918919,
                "width": 23.603603603603602,
                "height": 35.714285714285715
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8001720416340__PANDORO_BAILEYS_750G_H_1573489797.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_q0g7wqw_XOGVtVQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165810",
              "field1": "paluani",
              "field2": "profiteroles di pasticceria",
              "field3": "gr. 750",
              "field4": "",
              "description": "paluani profiteroles di pasticceria gr. 750",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 62.69305019305019,
                "left": 27.52252252252252,
                "width": 23.15315315315315,
                "height": 17.664092664092664
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PALUANI_PROFITEROLES_di_Pasticceria_750g_1542108805.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/2121404_PALUANI_FETTA_PROFITEROLES_1573470204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4xaZHCa_Gy37C09.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165812",
              "field1": "giovanni cova & c.",
              "field2": "panettone pistacchio incartato a mano",
              "field3": "kg. 1",
              "field4": "",
              "description": "giovanni cova & c. panettone pistacchio incartato a mano kg. 1",
              "grammage": null,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 80.35714285714286,
                "left": 27.52252252252252,
                "width": 23.15315315315315,
                "height": 17.76061776061776
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3259265_Cova_panettone_Pistacchio_kg.1_1605813599.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_teFZDRH_eeczT85.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197306",
              "field1": "prestige",
              "field2": "scatola x 28 - gr. 319",
              "field3": "",
              "field4": "",
              "description": "prestige scatola x 28 - gr. 319",
              "grammage": 319,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 69.73938223938224,
                "left": 50.67567567567568,
                "width": 24.23423423423423,
                "height": 27.509652509652504
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/FERRERO_PRESTIGE_T28X4_CARTIER_1542734605_1573490618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_5fEF2ni_QqoFh0O.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165835",
              "field1": "rocher ",
              "field2": "scatola",
              "field3": "x 24 gr. 300",
              "field4": "",
              "description": "rocher  scatola x 24 gr. 300",
              "grammage": 300,
              "price": "6.59",
              "price_label": "€ 6,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 69.73938223938224,
                "left": 74.9099099099099,
                "width": 22.52252252252252,
                "height": 27.509652509652504
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/T24_Rocher_1542992428.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_MHL4hVo_aunYOZw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0003_s6B1MC9.jpg",
          "products": [
            {
              "item_id": "197377",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 14.044401544401545,
                "left": 2.927927927927928,
                "width": 33.78378378378378,
                "height": 30.501930501930506
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3249133_Villa_guelfa_vassoio_GASTRONOMICO_11_PZ_1605809913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_5ptzqtt_TFBgJ0u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "cantine cav. ceste bottiglia merlot cl. 750, salumificio vecchi scatola cotechino cotto al vapore  gr. 450, molino di borgo s. dalmazzo sacchetto lenticchie portafortuna gr. 150, salumificio gonella  specialità salame al barolo gr. 125 ca., l'antica madia confezione gnocchetti pasta trafilata al bronzo gr. 250, saporie vaso sugo alla contadina gr. 185, monviso group astuccio rabatin al gorgonzola dop gr. 50, caffè corsini astuccio caffè pregiata miscela gr. 100, la sassellese scatola ciambelle al moscato gr. 90, molino filippini  confezione polenta del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_UwUGUeK.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239402",
              "field1": "regalidea",
              "field2": "vassoio onice",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio onice",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 14.044401544401545,
                "left": 36.711711711711715,
                "width": 25.120201732334888,
                "height": 30.501930501930506
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3254412_r.idea_vassoio_ONICE_PANDORO_7_PEZZI_1605813468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3m7CUMX_q6PLVLe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "melegatti pandoro incartato a mano gr. 500, gli artigiani della pasta fusilli gr. 250, fiore cantuccini con gocce di cioccolato gr. 100, caffarel praline le perle gr. 80, casa sant'orsola spumante dolce cuvée vol 9,5% bt cl. 75, lindor cioccolato fondente gr. 100",
                    "img": []
                  }
                }
              ]
            },
            {
              "item_id": "197294",
              "field1": "villa guelfa ",
              "field2": "elegante vassoio regalo litografato",
              "field3": "",
              "field4": "",
              "description": "villa guelfa  elegante vassoio regalo litografato",
              "grammage": null,
              "price": "19.90",
              "price_label": "€ 19,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 14.044401544401545,
                "left": 61.831913444046585,
                "width": 33.236686559493734,
                "height": 30.501930501930506
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3261237_Villa_guelfa_vassoio_DEL_CONVIVIO_7_PZ_1605814262.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_XqDOLxn_jpMy7F6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "pasticceria vergani  panettone classico di milano gr. 750, cantine cav. ceste  bottiglia cabernet cl. 75, l'antica madia confezione conchiglioni  pasta trafilata in bronzo gr. 250, saporie vaso sugo ai funghi gr. 185, monviso group astuccio langhetti artigianali all’olio di oliva gr. 100, molino di borgo s. dalmazzo confezione specialità minestrone del contadino gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_YnHXJVI.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239408",
              "field1": "villa guelfa",
              "field2": "cesto p.duomo",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cesto p.duomo",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.81854662018414,
                "left": 1.6513779410532357,
                "width": 47.27880681674988,
                "height": 26.00792633366399
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3249112_Villa_guelfa_cesto_DUOMO_PANETTONE_14_PZ_1605809388.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_J4WY4q4_zTpFCHH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "cesto rettangolare in vimini verniciato con riflessi oro, panettone classico milanese incartato a mano tre marie gr. 750, bottiglia spumante dolce millesimato 2019 cantine cav. ceste ml. 750, bottiglia cabernet cantine cav. ceste ml. 750, tavoletta cioccolato extra fondente con granella di caffè arabica  baratti & milano gr. 75, scatola pasticcini ricoperti al cioccolato fondente la sassellese gr. 100, scatola cotechino cotto al vapore  salumificio vecchi gr. 450, sacchetto lenticchie portafortuna  molino di borgo s. dalmazzo gr. 150, confezione pasta di gragnano igp i fidanzati capresi il vecchio pastificio di gragnano gr. 250, vaso sugo ai funghi  saporie gr. 185, astuccio pasticcini ripieni con crema alla nocciola  monviso group gr. 150, stecca torrone tenero ricoperto al cacao i siciliani gr. 100, ballotin cioccolatini classici  caffarel gr. 80, vaso squisita crema di nocciole casa costa gr. 200",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_mjrLsbH.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "197299",
              "field1": "villa guelfa",
              "field2": "cassetta contadina",
              "field3": "",
              "field4": "",
              "description": "villa guelfa cassetta contadina",
              "grammage": null,
              "price": "27.90",
              "price_label": "€ 27,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.81854662018414,
                "left": 48.93018475780312,
                "width": 47.004044789827674,
                "height": 26.00792633366399
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252493_Villa_guelfa_CASETTA_CONTADINA_10_PZ_1605812654.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_PZHcCKM_BHgvp1A.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "bottiglia cabernet  cantine cav. ceste cl. 75, scatola cotechino cotto al vapore salumificio vecchi gr. 450, specialità salame al barolo salumificio gonella, gr. 125 ca., sacchetto lenticchie portafortuna molino di borgo s. dalmazzo gr. 150, -trancio grana padano dop virgilio gr. 150 -astuccio rabatin al gorgonzola dop monviso group, gr. 50, confezione pasta di gragnano igp i fidanzati capresi  il vecchio pastificio di gragnano gr. 250, vaso sugo di pomodoro fresco dell'emilia romagna  le conserve della nonna gr. 190, confezione specialità minestrone del contadino  molino di borgo s. dalmazzo gr. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_USlli9y.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239401",
              "field1": "regalidea",
              "field2": "vassoio bellini",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio bellini",
              "grammage": null,
              "price": "17.90",
              "price_label": "€ 17,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.90329347549617,
                "left": 1.7324679115471413,
                "width": 30.682350213912425,
                "height": 27.180277528571253
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3254290_r.idea_cesto_BELLINI_PANDORO_7_PEZZI_1605812798.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_a7cyB30_I7vPvbM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "sapori cantuccini con gocce di cioccolato gr. 100, lindt cioccolato al latte lindor gr. 100, bauli pandoro classico gr. 500, sperlari torrone tenero alla mandorla gr. 75, casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, baratti babette caramelle gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_46PSUPN.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239407",
              "field1": "le cadeau",
              "field2": "cesto portofino",
              "field3": "",
              "field4": "",
              "description": "le cadeau cesto portofino",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.90329347549617,
                "left": 32.41481812545956,
                "width": 32.598400852764165,
                "height": 27.180277528571253
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252142_Lecadeau_cesto_PORTOFINO_PANDORO_17_PZ_1605810693.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_W4PnxhG_kjYkN4x.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "complemento d’arredo in stoffa con manici, tre marie panettone basso incartato a mano gr. 750, mionetto bottiglia spumante vivo cuvée blanc 11°ml. 750, cástano bottiglia vino merlot 11° ml. 750, vanoir astuccio pasticcini al cioccolato gr. 100, baratti & milano tavoletta cioccolato pere mandorle e miele gr. 75, sperlari sacchetto morbide gelatine alla frutta gr. 100, sperlari astuccio torrone alla mandorla gr. 75, dalla costa n° 2 confezioni pasta pennoni gr. 250, tenuta del cervo vaso sugo ai funghi porcini gr. 185, bellucci scatola cotechino cotto gr. 250, tenuta del cervo sacchetto lenticchie gr. 175, bontàloro misto funghi secchi con porcini gr. 15, motta sacchetto boules ripiene crema di nocciole gr. 85, corsini astuccio caffè gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_9gV84Qd.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239405",
              "field1": "le cadeau",
              "field2": "vassoio merry christmas",
              "field3": "",
              "field4": "",
              "description": "le cadeau vassoio merry christmas",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.90329347549617,
                "left": 65.01321897822373,
                "width": 30.955897295587135,
                "height": 27.180277528571253
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252120_Lecadeau_vassoio_MERRY_CHRISTMAS_PANETTONE_7_PZ_1605810290.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mQKwXWs_8pAA9zD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "bauli panettone incarto a mano gr. 500, sant’orsola spumante millesimato cuvèe dolce  9.5° ml. 750, baratti & milano tavoletta cioccolato extra fondente 70% gr. 75, motta sacchetto boules ripiene crema di nocciole gr. 85, sperlari sacchetto morbide gelatine alla frutta gr. 100, virginia confezione pasticcini panna e amarena gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_YXDfgmA.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0004_spkkV7Q.jpg",
          "products": [
            {
              "item_id": "165815",
              "field1": "maina",
              "field2": "grandi emozioni",
              "field3": "-panettone gr. 750 + sant'orsola spumante cl. 75",
              "field4": "-pandoro gr. 700 + sant'orsola spumante cl. 75",
              "description": "maina grandi emozioni -panettone gr. 750 + sant'orsola spumante cl. 75 -pandoro gr. 700 + sant'orsola spumante cl. 75",
              "grammage": 0,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Panettone",
                "Pandoro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 9.159625669623198,
                "left": 4.103212347001944,
                "width": 40.34770798155128,
                "height": 35.38671621544661
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3248893_Grandi_Emozioni_Pandoro_1605795903.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3248894_Grandi_Emozioni_Panettone_1605795972.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_NikeitF_JuiOxox.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197289",
              "field1": "balocco",
              "field2": "dolci emozioni",
              "field3": "",
              "field4": "",
              "description": "balocco dolci emozioni",
              "grammage": null,
              "price": "6.49",
              "price_label": "€ 6,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pandoro",
                "Panettone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 9.159625669623198,
                "left": 44.450920328553224,
                "width": 53.935137503145,
                "height": 35.38671621544661
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3261049_DolciEmozioni_PNT_8001100069838_1605813759.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3261050_DolciEmozioni_PND_8001100069845_1605813812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JmGIDTo_K0xRsly.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "pandoro/panettone gr. 750, sant'orsola spumante cl. 75 , lindor tavoletta cioccolato al latte gr. 100, vergani torrone gr. 75                                    ",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_ZM7N0Of.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "164065",
              "field1": "regalidea",
              "field2": "vassoio rustico con pandoro",
              "field3": "",
              "field4": "",
              "description": "regalidea vassoio rustico con pandoro",
              "grammage": null,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.720854513451,
                "left": 4.057021346450664,
                "width": 31.04830072327413,
                "height": 26.30101577218043
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252004_r.idea_vassoio_RUSTICO_PANDORO_9_PEZZI_1605809968.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_pAyoLmN_Fa4zIQs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "1 vassoio decorato, gli artigiani della pasta fusilli gr. 250, sfiziosi schiacciatine classiche gr. 100, casa sant’orsola spumante gran dessert 9,5% vol. cl. 75, cotechino cotto gr. 250, lenticchie della tradizione gr. 150, melegatti pandoro incartato a mano gr. 500, salame nostrano gr. 100, caffarel praline le perle gr. 80",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_FBFbmsZ.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239406",
              "field1": "le cadeau",
              "field2": "cesto verde smeraldo",
              "field3": "",
              "field4": "",
              "description": "le cadeau cesto verde smeraldo",
              "grammage": null,
              "price": "39.90",
              "price_label": "€ 39,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.720854513451,
                "left": 35.1053220697248,
                "width": 31.13826201670361,
                "height": 26.30101577218043
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252138_Lecadeau_cesto_VERDE_SMERALDO_PANETTONE_14_PZ_1605810627.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_8YKs1jO_yOkJwP8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "complemento d’arredo in velluto verde, bauli panettone incartato a mano gr. 750, sant’orsola spumante millesimato cuvée dolce  9.5° cl.75, sant’orsola bottiglia sangiovese  11.5° cl. 75, baratti & milano cioccolato bianco con foglie di menta piperita  gr. 75, giglio sacchetto croccantino ricoperto di cioccolato gr. 100, ricciarelli scatola alle mandorle fiore gr. 72, virginia confezione pasticcini pera e cioccolato gr. 80, piatti d’autore scatola cotechino cotto gr. 250, tenuta del cervo sacchetto lenticchie gr. 175, dalla costa confezione pasta pennoni gr. 250, tenuta del cervo vaso sugo ai funghi porcini gr. 185, bontàloro misto funghi secchi con porcini gr. 15, corsini astuccio caffè gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_L6XAyCJ.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "164122",
              "field1": "regalidea",
              "field2": "valigetta dolci auguri",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta dolci auguri",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 44.720854513451,
                "left": 66.24358408642843,
                "width": 32.233665288649945,
                "height": 26.30101577218043
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3254291_r.idea_STRENNA_DOLCI_AUGURI_PANDORO_5_PEZZI_1605813349.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_uKrTfwH_xQAQg59.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "casa sant'orsola spumante dolce cuvée vol 9,5% cl.75, sapori cantuccini con gocce di cioccolato gr. 100, melegatti pandoro / panettone gr. 500, cuor di langhe praline al latte crema nocciola gr. 70, lindt cioccolato latte gr. 100",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_0MnphRT.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239404",
              "field1": "lecadeau",
              "field2": "strenna caffarel con particolare scatola a cuspide",
              "field3": "",
              "field4": "",
              "description": "lecadeau strenna caffarel con particolare scatola a cuspide",
              "grammage": null,
              "price": "23.90",
              "price_label": "€ 23,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.80559808918377,
                "left": 4.148203707008901,
                "width": 30.86592681933576,
                "height": 27.375668301196047
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3259384_Le_cadeau_strenna_CAFFAREL_PANETTONE_5_PZ_1605813728.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Akhg3JD_TgFDKK7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "caffarel panettone cellophane gr. 750, ca’ de medici  spumante cuveè blanc de blancs 11° ml. 750, caffarel tavoletta cioccolato fondente gr. 80, caffarel confezione le perle di cioccolato gr. 93, caffarel scatola gelatine alla frutta gr. 93",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_lr3Wb44.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239403",
              "field1": "regalidea",
              "field2": "valigetta lavazza",
              "field3": "",
              "field4": "",
              "description": "regalidea valigetta lavazza",
              "grammage": null,
              "price": "22.90",
              "price_label": "€ 22,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.80559808918377,
                "left": 35.01413052634466,
                "width": 31.22945049914312,
                "height": 27.375668301196047
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3263899_r.idea_STRENNA_LAVAZZA_PANETTONE_6_PEZZI_1605814233.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_X3O8aKp_PRNf1dW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "casa sant'orsola spumante dolce cuvée vol 9,5% bt cl.75, lavazza caffè tierra brasile gr. 180, balocco panettone gr. 500, lavazza caffè tierra perù gr.180, lavazza caffè oro d'altura gr. 250, baratti cioccolato extra fondente 70% gr. 75",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_DEpQwaJ.jpg"
                    ]
                  }
                }
              ]
            },
            {
              "item_id": "239400",
              "field1": "parmigiano reggiano",
              "field2": "valigetta gran gourmet",
              "field3": "",
              "field4": "",
              "description": "parmigiano reggiano valigetta gran gourmet",
              "grammage": null,
              "price": "20.90",
              "price_label": "€ 20,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 70.80559808918377,
                "left": 66.24358102548777,
                "width": 32.051297506592846,
                "height": 27.375668301196047
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3252076_Lecadeau_valigetta_GRAN_GOURMET_10_PZ_1605810219.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_zH2iOvT_qHlWrsk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "specs",
                  "title": "Composizione",
                  "data": {
                    "specifiche": "coltellino taglia formaggio del consorzio del parmigiano reggiano, mini ricettario del consorzio del parmigiano reggiano, trancio di parmigiano reggiano dop stagionato 30 mesi gr. 150, cà de medici bottiglia lambrusco reggiano doc 11° ml. 750, la loggia dei grani n° 2 confezioni pasta le casarecce gr. 250, tenuta del cervo vaso sugo al parmigiano reggiano gr. 190, antichi sapori d’italia salame del contadino gr. 100, tenuta del cervo granelli al parmigiano reggiano gr. 100, l’aceto reale bottiglia aceto balsamico di modena ml. 250",
                    "img": [
                      "https://interattivo.s3.amazonaws.com/zJhLivpIOk/images/1_PtW2fKK.jpg"
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0005_nVw6qlK.jpg",
          "products": [
            {
              "item_id": "165840",
              "field1": "rocca dei forti",
              "field2": "spumante",
              "field3": "cl. 75",
              "field4": "-brut -dolce",
              "description": "rocca dei forti spumante cl. 75 -brut -dolce",
              "grammage": 750,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut",
                "Dolce"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 6.921394207122628,
                "left": 1.6142207138995113,
                "width": 22.339745677462076,
                "height": 37.80822764838181
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Rocca_dei_Forti_spumante__Dolce_cl.75_1542027889.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Rocca_dei_Forti_spumante_Brut_cl.75_1542027890.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_C9SrMe4_fCxWJoH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133987",
              "field1": "caffo",
              "field2": "vecchio amaro del capo",
              "field3": "cl. 70",
              "field4": "",
              "description": "caffo vecchio amaro del capo cl. 70",
              "grammage": 700,
              "price": "8.99",
              "price_label": "€ 8,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 16.007094650388808,
                "left": 23.95396639136159,
                "width": 22.613292759136783,
                "height": 28.722527205115625
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Vecchio_amaro_del_capo_70_cl_1447781912_1464966848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4MG7aAu_Rs1irro.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165853",
              "field1": "baileys ",
              "field2": "classico",
              "field3": "cl. 70",
              "field4": "",
              "description": "baileys  classico cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 16.007094650388808,
                "left": 46.56725915049837,
                "width": 19.604265677893057,
                "height": 28.722527205115625
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/baileys_70_cl_1542990091.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_tUAHoFB_4p0Zce3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165844",
              "field1": "ferrari",
              "field2": "spumante in astuccio",
              "field3": "cl. 75",
              "field4": "-brut doc -demi-sec",
              "description": "ferrari spumante in astuccio cl. 75 -brut doc -demi-sec",
              "grammage": 750,
              "price": "13.50",
              "price_label": "€ 13,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut doc",
                "Demi",
                "Sec"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 14.541657296544354,
                "left": 66.17152482839143,
                "width": 29.451997349470286,
                "height": 30.187964558960083
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ferrari_brut_1542991048.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ferrari_demisec_1542991049.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_W62JzSJ_rfTIHZr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165845",
              "field1": "mumm",
              "field2": "champagne cordon rouge brut",
              "field3": "cl. 75",
              "field4": "",
              "description": "mumm champagne cordon rouge brut cl. 75",
              "grammage": 750,
              "price": "24.90",
              "price_label": "€ 24,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 44.53423108287964,
                "left": 1.705400013517114,
                "width": 18.601259711752444,
                "height": 18.07370222064072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MUMM_CORDON_ROUGE_CHAMPAGNE_CL.75ASTUCCIO_1542027872.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1iTur25_saU1uGb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164078",
              "field1": "cinzano",
              "field2": "spumante dolce sweet edition",
              "field3": "cl. 75",
              "field4": "",
              "description": "cinzano spumante dolce sweet edition cl. 75",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 44.53423108287964,
                "left": 20.306659725269558,
                "width": 18.69243901137005,
                "height": 18.07370222064072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CINZANO_SWEET_EDITION_SPUM.DOLCE_CL.75_1540909848.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_fVQU8MG_oHwGUoc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165843",
              "field1": "cinzano",
              "field2": "spumante asti docg",
              "field3": "cl. 75",
              "field4": "",
              "description": "cinzano spumante asti docg cl. 75",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 44.53423108287964,
                "left": 38.99909873663961,
                "width": 18.510080412134844,
                "height": 18.07370222064072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Cinzano_Asti_spumante_cl.75_1542027813.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_09V6vck_nkpSrcF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130315",
              "field1": "bolla ",
              "field2": "prosecco valdobbiadene superiore ",
              "field3": "extra dry docg",
              "field4": "cl. 75",
              "description": "bolla  prosecco valdobbiadene superiore  extra dry docg cl. 75",
              "grammage": 750,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 44.53423108287964,
                "left": 57.50917914877446,
                "width": 18.601253589871177,
                "height": 18.07370222064072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/68755__Bolla_Prosecco_DOCG_EXTRA_DRY_1484306019.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_N1p96VZ_h7tTnc5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165846",
              "field1": "sandiliano",
              "field2": "spumante grand cuvee",
              "field3": "cl. 75",
              "field4": "-brut -dessert",
              "description": "sandiliano spumante grand cuvee cl. 75 -brut -dessert",
              "grammage": 750,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brut",
                "Dessert"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 44.53423108287964,
                "left": 76.11043273864563,
                "width": 19.877812759567767,
                "height": 18.07370222064072
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Sandiliano_brut_cl.75_1542027910.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Sandiliano_dessert_cl.75_1542027910.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_rPBCudn_vJZeAKT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180792",
              "field1": "santa margherita",
              "field2": "prosecco extra dry doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "santa margherita prosecco extra dry doc cl. 75",
              "grammage": 750,
              "price": "4.69",
              "price_label": "€ 4,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 62.60793330352036,
                "left": 1.705393891635845,
                "width": 18.510083473075476,
                "height": 17.87830488885742
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Prosecco_Doc_Extra_Dry_P_1558516165_1559122607.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_NZGRUIh_GEjEUuZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239414",
              "field1": "perlino",
              "field2": "fragolino rosso",
              "field3": "cl. 75",
              "field4": "",
              "description": "perlino fragolino rosso cl. 75",
              "grammage": 750,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 62.60793330352036,
                "left": 20.21547736471132,
                "width": 18.692432889488778,
                "height": 17.87830488885742
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Perlino_fragolino_cl_1605810677.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_YaNJmb0_rxyjehu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139599",
              "field1": "limoncè",
              "field2": "cl. 50",
              "field3": "-classico -crema",
              "field4": "",
              "description": "limoncè cl. 50 -classico -crema",
              "grammage": 500,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Crema"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 62.60793330352036,
                "left": 38.9079102542001,
                "width": 18.51008653401611,
                "height": 17.87830488885742
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Limonce_crema_cl.50_astuccio_1605810458.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/LImonce_cl.50_astuccio_1605810529.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_VPzMBz4_ya7ushe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165850",
              "field1": "glen grant",
              "field2": "whisky 5 years",
              "field3": "cl. 70",
              "field4": "",
              "description": "glen grant whisky 5 years cl. 70",
              "grammage": 700,
              "price": "12.50",
              "price_label": "€ 12,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 62.60793330352036,
                "left": 57.417996788216215,
                "width": 18.692420645726244,
                "height": 17.87830488885742
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/glen_grant_1542991274.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yYQgl7Z_bf3NWEL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164082",
              "field1": "ballantine's",
              "field2": "whisky",
              "field3": "cl. 70",
              "field4": "",
              "description": "ballantine's whisky cl. 70",
              "grammage": 700,
              "price": "9.90",
              "price_label": "€ 9,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 62.60793330352036,
                "left": 76.11041743394246,
                "width": 19.969016546710446,
                "height": 17.87830488885742
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Ballantines_Whisky_cl.70_1540909686.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_H4gJSjW_0fIshCq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165852",
              "field1": "amaretto disaronno",
              "field2": "",
              "field3": "cl. 70",
              "field4": "",
              "description": "amaretto disaronno cl. 70",
              "grammage": 700,
              "price": "9.99",
              "price_label": "€ 9,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 80.38854608564463,
                "left": 1.7965915568972541,
                "width": 18.418864381229625,
                "height": 17.87831144801592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/0019463_Disaronno_1531469287_1574246913.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_XGNCy0K_iYiedED.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165848",
              "field1": "segnana",
              "field2": "grappa solera di solera",
              "field3": "cl. 70",
              "field4": "",
              "description": "segnana grappa solera di solera cl. 70",
              "grammage": 700,
              "price": "14.90",
              "price_label": "€ 14,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Liquori",
              "blueprint": {
                "top": 80.38854608564463,
                "left": 20.215455938126883,
                "width": 18.874837402833503,
                "height": 17.87831144801592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Segnana_grappa_solera_di_solera_cl.70_1542109616.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_2A9MYJr_7XZX1lH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139589",
              "field1": "crodino",
              "field2": "",
              "field3": "cl. 10 x 10",
              "field4": "-biondo -arancia rossa",
              "description": "crodino cl. 10 x 10 -biondo -arancia rossa",
              "grammage": 0,
              "price": "5.29",
              "price_label": "€ 5,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Biondo",
                "Arancia rossa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 80.38854608564463,
                "left": 39.09029334096038,
                "width": 29.178410475567325,
                "height": 17.87831144801592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/54346_1509631467_1534501615.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Crodino_x_10_1495871308_1533060315_1534501635.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_z8yLCz7_a6ijCtk.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139588",
              "field1": "campari",
              "field2": "soda\t",
              "field3": "cl. 10 x 5",
              "field4": "",
              "description": "campari soda\t cl. 10 x 5",
              "grammage": 500,
              "price": "4.90",
              "price_label": "€ 4,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 80.38854608564463,
                "left": 68.26870381652772,
                "width": 27.81073322506582,
                "height": 17.87831144801592
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Campari_soda_cl.10x5_1605809043.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ZPPaDzM_xLDiEWO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 6,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0006_IAqU2U2.jpg",
          "products": [
            {
              "item_id": "231273",
              "field1": "facino",
              "field2": "insalata di mare con verdure",
              "field3": "deliziosa",
              "field4": "kg. 1",
              "description": "facino insalata di mare con verdure deliziosa kg. 1",
              "grammage": 0,
              "price": "4.99",
              "price_label": "€ 4,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 14.346264884129933,
                "left": 3.984968210294947,
                "width": 28.357799839949536,
                "height": 30.090267532858064
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Facino_Insalata_di_Mare_con_verdure_kg.1_1598515937.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_lp22tK3_OEcUz1p.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164135",
              "field1": "baccalà ",
              "field2": "secco gadus morhua ",
              "field3": "16/20 ali bianche ",
              "field4": "imbustato al kg",
              "description": "baccalà  secco gadus morhua  16/20 ali bianche  imbustato al kg",
              "grammage": 0,
              "price": "12.50",
              "price_label": "€ 12,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 14.737046429379523,
                "left": 32.34276805024449,
                "width": 30.728547336344977,
                "height": 29.699485987608472
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3254369_Baccala_secco_1620_ali_bianche_busta_singola__1601022365.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3ouYqoZ_VyhPuwu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162516",
              "field1": "philadelphia",
              "field2": "classica ",
              "field3": "gr. 150",
              "field4": "",
              "description": "philadelphia classica  gr. 150",
              "grammage": 150,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 44.436532416987994,
                "left": 32.34276805024449,
                "width": 30.728547336344977,
                "height": 21.688439713147535
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PHILADELPHIA_150_1521712973_1521714151_1521824660_1521827200_1535624_wCWpEYw.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_eTE9hVt_3LAbXVJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "177238",
              "field1": "pam",
              "field2": "pane da tramezzini",
              "field3": "gr. 250",
              "field4": "",
              "description": "pam pane da tramezzini gr. 250",
              "grammage": 250,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 66.12497213013552,
                "left": 4.076150570853184,
                "width": 37.293698723122496,
                "height": 12.01657023158622
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pam_pane_da_tramezzini_gr_250_1586857699.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_REVKMwa_dRpoBT4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239413",
              "field1": "nuova jolly",
              "field2": "insalata",
              "field3": "-capricciosa -russa con tonno -russa",
              "field4": "gr. 1000",
              "description": "nuova jolly insalata -capricciosa -russa con tonno -russa gr. 1000",
              "grammage": null,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Capricciosa",
                "Russa con tonno",
                "Russa"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Vegetali",
              "blueprint": {
                "top": 66.12497213013552,
                "left": 41.369849293975676,
                "width": 21.245557350763228,
                "height": 31.55570652649214
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Jolli_insalata_capricciosa_1605880789.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/insalata_russa_con_tonno_1605880790.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ssyBrEk_ilomAgz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239412",
              "field1": "pam",
              "field2": "i tesori ",
              "field3": "-pesce spada affumiicato gr. 100",
              "field4": "-tonno affumicato gr. 100 ",
              "description": "pam i tesori  -pesce spada affumiicato gr. 100 -tonno affumicato gr. 100 ",
              "grammage": 100,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pesce spada",
                "Tonno"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 79.70467018250973,
                "left": 3.984974332176216,
                "width": 31.458006220810876,
                "height": 17.976008474117947
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8004263686881_T70_1606315260.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8004263686898_T70_1606315261.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4g4JuFn_4gNHivJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197318",
              "field1": "bottega del mare",
              "field2": "salmone selvaggio sockey",
              "field3": "astuccio gr. 80",
              "field4": "",
              "description": "bottega del mare salmone selvaggio sockey astuccio gr. 80",
              "grammage": 80,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 6.823697181020606,
                "left": 62.88895372641361,
                "width": 18.783621371928287,
                "height": 17.878309808226298
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Bottega_del_mare_salmone_selvaggio_affumicato_gr.80_1573482705.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_vGFV5S7_ds2BpSP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165874",
              "field1": "norita",
              "field2": "filetto salmone norvegese affumicato",
              "field3": "astuccio gr. 250",
              "field4": "",
              "description": "norita filetto salmone norvegese affumicato astuccio gr. 250",
              "grammage": 250,
              "price": "8.90",
              "price_label": "€ 8,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 24.702006989246904,
                "left": 62.88895372641361,
                "width": 35.37886609045888,
                "height": 11.137308475195397
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Norita_filetto_di_salmone_norvegese_gr.250_1542120954.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_N9jS6nE_03PHJTF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239411",
              "field1": "La NEF  RE salmone",
              "field2": "norvegese affumicato",
              "field3": "astuccio",
              "field4": "gr. 600",
              "description": "La NEF  RE salmone norvegese affumicato astuccio gr. 600",
              "grammage": 600,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 35.8393154644423,
                "left": 62.88895372641361,
                "width": 35.37886609045888,
                "height": 12.798136601664648
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ReSalmone_Baffa_senza_pelle_1606490978.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_QekqcPa_j4cb9RM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165872",
              "field1": "norita",
              "field2": "salmone norvegese affumicato",
              "field3": "preaffettato gr. 200",
              "field4": "",
              "description": "norita salmone norvegese affumicato preaffettato gr. 200",
              "grammage": 200,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 48.637452066106945,
                "left": 62.88895372641361,
                "width": 35.37886609045888,
                "height": 13.188914867334987
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Norita_salmone_norvegese_affumicato_gr.200_astuccio_1542120983.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_9ra8u2s_2dzbGbs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166823",
              "field1": "fini ",
              "field2": "zampone modena igp ",
              "field3": "kg. 1",
              "field4": "",
              "description": "fini  zampone modena igp  kg. 1",
              "grammage": null,
              "price": "10.99",
              "price_label": "€ 10,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 61.82636693344193,
                "left": 62.88895372641361,
                "width": 17.32470360299649,
                "height": 18.464485405679934
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/G7188_New_Foto_Zampone_kg_1_Fini_1575371397.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_QeI17BC_AOYqCCp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166811",
              "field1": "fini",
              "field2": "cotechino modena igp",
              "field3": "gr. 500",
              "field4": "",
              "description": "fini cotechino modena igp gr. 500",
              "grammage": 500,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 80.29085233912186,
                "left": 62.88895372641361,
                "width": 17.32470360299649,
                "height": 17.682919035601504
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/G7183_New_Foto_Cotechino_gr._500_Fini_1575371419.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_91WDTI1_a3lgbZS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166848",
              "field1": "excelsior ",
              "field2": "filetto di baccalà gadus morhua vaschetta ",
              "field3": "gr. 500 circa",
              "field4": "al kg",
              "description": "excelsior  filetto di baccalà gadus morhua vaschetta  gr. 500 circa al kg",
              "grammage": null,
              "price": "12.90",
              "price_label": "€ 12,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 61.533282414294355,
                "left": 80.2136573294101,
                "width": 17.78061234484704,
                "height": 36.440488960429
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Baccala_filetto_vaschetta_gr.500_1542639464.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ZqDDeST_2bAKKY4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 7,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0007_ceMoYCM.jpg",
          "products": [
            {
              "item_id": "130313",
              "field1": "corvo di salaparuta ",
              "field2": "vino igt",
              "field3": "cl. 75",
              "field4": "-rosso -rosato -bianco sicilia",
              "description": "corvo di salaparuta  vino igt cl. 75 -rosso -rosato -bianco sicilia",
              "grammage": 750,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Rosso",
                "Rosato",
                "Bianco Sicilia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 6.823697181020606,
                "left": 2.6172236190994864,
                "width": 37.658431226296074,
                "height": 33.70500994473375
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CORVO_Bianco_cl.75_1584123041.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CORVO_Rosato_cl.75_1584123042.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CORVO_Rosso_cl.75_1584123043.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_6h3NQII_U4ULyWz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165818",
              "field1": "san martino terrantica di puglia",
              "field2": "valigetta 3 vini da cl. 75",
              "field3": "",
              "field4": "composizione: -primitivo igp salento -locorotondo dop -negroamaro igp salento",
              "description": "san martino terrantica di puglia valigetta 3 vini da cl. 75 composizione: -primitivo igp salento -locorotondo dop -negroamaro igp salento",
              "grammage": null,
              "price": "7.99",
              "price_label": "€ 7,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 2.6172236190994864,
                "width": 19.14835387510187,
                "height": 18.855270230508772
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/San_Martino_Valigetta_x3_TerrAntica_Prim-Loc-Negr_1573489538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yttDOSu_YKsphmP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "211374",
              "field1": "de castris five roses",
              "field2": "vino rosato igt",
              "field3": "cl. 75",
              "field4": "",
              "description": "de castris five roses vino rosato igt cl. 75",
              "grammage": 750,
              "price": "6.99",
              "price_label": "€ 6,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 21.765577494201352,
                "width": 18.51007735119421,
                "height": 18.855270230508772
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Five-Roses_1594823616.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_rYJUHcp_5uMvRH1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino di puglia igt",
              "field3": "cl. 75",
              "field4": "-bianco -rosato",
              "description": "donna marzia vino di puglia igt cl. 75 -bianco -rosato",
              "grammage": 750,
              "price": "2.89",
              "price_label": "€ 2,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianco",
                "Rosato"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.38397735626312,
                "left": 2.7084090405983545,
                "width": 12.583199427383715,
                "height": 18.562177512413076
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DONNA_MARZIA_BIANCO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DONNA_MARZIA_ROSATO_cl.75_1533303678_1546872943.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_sWFsPJi_sMSnv57.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130288",
              "field1": "donna marzia",
              "field2": "vino rosso di puglia igt",
              "field3": "cl. 75",
              "field4": "",
              "description": "donna marzia vino rosso di puglia igt cl. 75",
              "grammage": 750,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.38397735626312,
                "left": 15.29160846798207,
                "width": 12.856755691880329,
                "height": 18.562177512413076
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DONNA_MARZIA_ROSSO_cl.75_1533303702_1606328544.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_0tIiwfq_L27eG1y.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140780",
              "field1": "soloperto",
              "field2": "primitivo manduria riserva doc",
              "field3": "cl. 75",
              "field4": "",
              "description": "soloperto primitivo manduria riserva doc cl. 75",
              "grammage": 750,
              "price": "6.49",
              "price_label": "€ 6,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 59.38397735626312,
                "left": 28.1483641598624,
                "width": 12.127290685533161,
                "height": 18.562177512413076
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/soloperto_primitivo_di_manuria_1537354107.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_7nwVEYm_7yAGnrB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231266",
              "field1": "casalfarneto",
              "field2": "vino passerina marche",
              "field3": "bianco igt",
              "field4": "cl. 75",
              "description": "casalfarneto vino passerina marche bianco igt cl. 75",
              "grammage": 750,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 77.9461548686762,
                "left": 2.7084090405983576,
                "width": 18.965986093044762,
                "height": 20.613790463711165
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Casal_farnetto_Passerina_1598953268.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3xVLjUp_4gDMCVq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137280",
              "field1": "la marca",
              "field2": "vino del sannio dop",
              "field3": "cl. 75",
              "field4": "-falanghina -aglianico",
              "description": "la marca vino del sannio dop cl. 75 -falanghina -aglianico",
              "grammage": 750,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Falanghina",
                "Aglianico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Vini e Spumanti",
              "blueprint": {
                "top": 77.9461548686762,
                "left": 21.674395133643117,
                "width": 19.057174575484265,
                "height": 20.613790463711165
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/La_Marca_Aglianico_dop_cl.75_1533303755.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/La_Marca_Falanghina_dop_cl.75_1533303755.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_X2rUs7f_EXo3cQh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239419",
              "field1": "parmigiano reggiano dop",
              "field2": "vacche rosse ",
              "field3": "stagionato oltre 24 mesi",
              "field4": "l'etto",
              "description": "parmigiano reggiano dop vacche rosse  stagionato oltre 24 mesi l'etto",
              "grammage": 100,
              "price": "2.19",
              "price_label": "€ 2,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 7.116784979747423,
                "left": 41.00511985174273,
                "width": 34.19348622037989,
                "height": 32.53266038961612
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606141928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/VACCHE_ROSSE_Formaggio_1606754353.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_dOzDjQL_wW2TFRK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131534",
              "field1": "emmentaler",
              "field2": "switzerland dop",
              "field3": "l'etto",
              "field4": "",
              "description": "emmentaler switzerland dop l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 41.114876164049484,
                "left": 40.82274900874499,
                "width": 19.239536235660108,
                "height": 18.36679165915716
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/EMMENTALER_1562605027.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606142147.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_zNymM6i_8BZccdu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239420",
              "field1": "pecorino di amatrice",
              "field2": "formaggio",
              "field3": "semistagionato",
              "field4": "l'etto",
              "description": "pecorino di amatrice formaggio semistagionato l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 41.114876164049484,
                "left": 60.06228524440509,
                "width": 19.05717151454363,
                "height": 18.36679165915716
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PETRUCCI__PECORINO_AMATRICE_1605784703.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_UEhz8a6_Rm1v9bY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139406",
              "field1": "busti",
              "field2": "le delizie pecorino fresco",
              "field3": "l'etto",
              "field4": "-mandorle -pistacchi bronte dop",
              "description": "busti le delizie pecorino fresco l'etto -mandorle -pistacchi bronte dop",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Mandorle",
                "Pistacchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 41.114876164049484,
                "left": 79.11945675894871,
                "width": 17.871797766345914,
                "height": 18.36679165915716
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BUSTI__Mandorlo_di_Pura_Pecora_1_1535990621_1544437788.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Busti_pecorino__Il_Pistacchio_1535990621_1544437812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606142205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_CwklTMp_MItruhb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131544",
              "field1": "leonardi",
              "field2": "gran riserva gorgonzola dolce dop al cucchiaio",
              "field3": "l'etto",
              "field4": "",
              "description": "leonardi gran riserva gorgonzola dolce dop al cucchiaio l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.48166782320664,
                "left": 79.11945675894871,
                "width": 17.871797766345914,
                "height": 18.659867979356598
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/fetta_gorgonzola_Santi_1446631679_1519141915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/leonardi_gran_riserva_1602225683.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606142282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_K1s9RsW_MPoIVyP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132599",
              "field1": "auricchio",
              "field2": "dolce ",
              "field3": "-provoletta -salamino",
              "field4": "l'etto",
              "description": "auricchio dolce  -provoletta -salamino l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Provoletta",
                "Salamino"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.48166782320664,
                "left": 60.24465608740284,
                "width": 18.87480067154589,
                "height": 18.659867979356598
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/auricchio_provolette_1606487163.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Vl64ycZ_Q0AnCbT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "172734",
              "field1": "auricchio",
              "field2": "provolone stravecchio",
              "field3": "l'etto",
              "field4": "",
              "description": "auricchio provolone stravecchio l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.48166782320664,
                "left": 40.458019566512036,
                "width": 19.7866365208908,
                "height": 18.659867979356598
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/auricchio_stravecchio_mandarone_1483356738_1511371570_1533221200.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3VMU9pg_ECRBmx5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239421",
              "field1": "torta",
              "field2": "gorgonzola&mascarpone con noci",
              "field3": "l'etto",
              "field4": "",
              "description": "torta gorgonzola&mascarpone con noci l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Piatti Pronti",
              "blueprint": {
                "top": 78.14153580256324,
                "left": 40.458019566512036,
                "width": 19.7866365208908,
                "height": 20.320712503722103
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/torta_gorgonzolamascarpone_con_noci_1606295928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_eQcDFHN_DTqtDet.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239422",
              "field1": "mauri",
              "field2": "fioroni di capra alle erbe",
              "field3": "gr. 90 circa",
              "field4": "l'etto",
              "description": "mauri fioroni di capra alle erbe gr. 90 circa l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.14153580256324,
                "left": 60.24465608740284,
                "width": 18.601250528930542,
                "height": 20.320712503722103
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/266_1606295846.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_2ZV5yQk_GbAISEF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131553",
              "field1": "nonno nanni",
              "field2": "stracchino classico",
              "field3": "gr. 200 circa",
              "field4": "l'etto",
              "description": "nonno nanni stracchino classico gr. 200 circa l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 78.14153580256324,
                "left": 78.84590661633338,
                "width": 18.327724873840275,
                "height": 20.320712503722103
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Stracchino_Nonno_Nanni_200g_1582284555_1592228248.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/impiattato_stracchino-bio-781x521_1592577414.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mKjCvVU_3VXJGux.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 8,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0008_PAnplfV.jpg",
          "products": [
            {
              "item_id": "134707",
              "field1": "parmigiano reggiano dop",
              "field2": "stagionato 24 mesi",
              "field3": "l'etto",
              "field4": "",
              "description": "parmigiano reggiano dop stagionato 24 mesi l'etto",
              "grammage": 1000,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 10.243045540692256,
                "left": 2.7084090405983576,
                "width": 48.41798038157441,
                "height": 29.015618283421695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/logo_parmigiano_reggiano_1526023058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/parmigiano_pezzi_auchan_1521041260_1540980547_1558444713.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/22760_1574332008.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606141898.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4tVEGV9_m1n7Hvz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130161",
              "field1": "asiago",
              "field2": "fresco dop",
              "field3": "l'etto",
              "field4": "",
              "description": "asiago fresco dop l'etto",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 10.243045540692256,
                "left": 51.12638942217277,
                "width": 47.05024191226022,
                "height": 29.015618283421695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/asiago_fresco_1535464821_1603265396.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/asiago_fresco_dop_1603354834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606141963.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Fk1yP41_AG71OaQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130143",
              "field1": "veroni",
              "field2": "prosciutto affumicato",
              "field3": "l'appetitoso",
              "field4": "l'etto",
              "description": "veroni prosciutto affumicato l'appetitoso l'etto",
              "grammage": 100,
              "price": "1.69",
              "price_label": "€ 1,69 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.258663824113945,
                "left": 73.64849675981068,
                "width": 24.528134574622307,
                "height": 19.929921119734765
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/VERONI_PROSCIUTTO_AFFUMICATO_LAPPETITOSO_1530541540_1535385252.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/piatto_prosciutto_cotto_1588066373.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_LD7akbS_DqmdBlR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "195879",
              "field1": "la bufalat",
              "field2": "mozzarella di bufala dop",
              "field3": "gr. 250",
              "field4": "tutti i tipi",
              "description": "la bufalat mozzarella di bufala dop gr. 250 tutti i tipi",
              "grammage": 250,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 39.258663824113945,
                "left": 50.03219803453329,
                "width": 23.616298725277392,
                "height": 19.929921119734765
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/LA_BUFALAT_MOZZARELLE_BUFALA_DOP_G250_1593505371.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/LA_BUFALAT_MOZZARELLA_BUFALA_DOP_x5_GR.250_1593018966_1593507399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606142368.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_SwnWmFr_eRBofDj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "173545",
              "field1": "burrata di andria",
              "field2": "igp",
              "field3": "in foglia",
              "field4": "gr. 350 circa l'etto",
              "description": "burrata di andria igp in foglia gr. 350 circa l'etto",
              "grammage": 100,
              "price": "0.89",
              "price_label": "€ 0,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.258663824113945,
                "left": 26.23352846625815,
                "width": 23.798669568275137,
                "height": 19.929921119734765
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/burrata_in_piatto_1530889237_1551522973.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/burrata_di_andria_igp_1551720906.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_IGP_1606142325.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_fmaaKQU_THOXG6t.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132573",
              "field1": "negroni",
              "field2": "petto di tacchino arrosto ",
              "field3": "l'etto",
              "field4": "",
              "description": "negroni petto di tacchino arrosto  l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.18858494384871,
                "left": 26.23352846625815,
                "width": 23.798669568275137,
                "height": 18.659876178304728
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/negroni_Petto_Di_Tacchino__1535450295.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_TzdOkXw_CjTbpIM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134689",
              "field1": "coati ",
              "field2": "prealpen speck",
              "field3": "l'etto",
              "field4": "",
              "description": "coati  prealpen speck l'etto",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.18858494384871,
                "left": 50.03219803453329,
                "width": 23.79866344639387,
                "height": 18.659876178304728
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Speck_piatto_1511363327.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/coati_PrealpenSpeck_1542641430_1575455895.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_LnrbSZe_EVXAPr6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134690",
              "field1": "lazzeri",
              "field2": "bresaola ",
              "field3": "punta d’anca igp",
              "field4": "l'etto",
              "description": "lazzeri bresaola  punta d’anca igp l'etto",
              "grammage": 100,
              "price": "2.59",
              "price_label": "€ 2,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.18858494384871,
                "left": 73.83086148092715,
                "width": 24.3457759753871,
                "height": 18.659876178304728
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/LAZZERI_BRESAOLA_IGP__1532682073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/bresaola_carpaccio_1523452035_1529687991_1551522451_1562594337_1590484299.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_IGP_1606141854.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_snspofU_OEdNsJ4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239418",
              "field1": "clai",
              "field2": "salame nobile italiano",
              "field3": "l'etto",
              "field4": "",
              "description": "clai salame nobile italiano l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 77.84846112215344,
                "left": 73.83086148092715,
                "width": 24.3457759753871,
                "height": 20.320704304773976
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Salame_Nobile_1606381151.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_UFviVUT_CGA0f76.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239417",
              "field1": "king's",
              "field2": "rebello culatta stagionata",
              "field3": "l'etto",
              "field4": "",
              "description": "king's rebello culatta stagionata l'etto",
              "grammage": 100,
              "price": "2.89",
              "price_label": "€ 2,89 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 77.84846112215344,
                "left": 50.12338957791343,
                "width": 23.70747190301373,
                "height": 20.320704304773976
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/kings_rebello_culatello_1480434115_1605714926.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/snocciolato_crudo_Piatto_1480434116_1605714927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_VOLmpnq_gIjzOvd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "204467",
              "field1": "parigini ",
              "field2": "pane precotto",
              "field3": "al kg",
              "field4": "",
              "description": "parigini  pane precotto al kg",
              "grammage": 0,
              "price": "2.49",
              "price_label": "€ 2,49 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Panetteria",
              "blueprint": {
                "top": 77.84846112215344,
                "left": 26.324707765875754,
                "width": 23.79868181203767,
                "height": 20.320704304773976
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Sfilatino_1580987208.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_nk0UYqv_KxbQvZK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165866",
              "field1": "biffi",
              "field2": "salsa per formaggi",
              "field3": "gr. 100",
              "field4": "-di fichi -di pere",
              "description": "biffi salsa per formaggi gr. 100 -di fichi -di pere",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Di fichi",
                "Di pere"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 39.16097007759117,
                "left": 2.708421284360889,
                "width": 23.616286481514862,
                "height": 59.00819534933624
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BIFFI_SALSA_G100_FICHI_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BIFFI_SALSA_G100_PERE_1542109987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_6QmF8F5_8wSNhy1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 9,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0009_Kp180XE.jpg",
          "products": [
            {
              "item_id": "132579",
              "field1": "king's",
              "field2": "prosciutto san daniele dop",
              "field3": "l'etto",
              "field4": "",
              "description": "king's prosciutto san daniele dop l'etto",
              "grammage": 100,
              "price": "2.49",
              "price_label": "€ 2,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 1.7435256142485815,
                "left": 1.796597678778517,
                "width": 48.326782716313005,
                "height": 37.417449382711474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/prosciutto_crudo_san_daniele_con_osso_1443790141_1544181461_1561023761.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_DOP_1606141765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_LF4RjKW_8Qji23Z.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130115",
              "field1": "palmieri",
              "field2": "mortadella favola in cotenna",
              "field3": "l'etto",
              "field4": "",
              "description": "palmieri mortadella favola in cotenna l'etto",
              "grammage": 100,
              "price": "1.19",
              "price_label": "€ 1,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 1.7435256142485815,
                "left": 50.12338039509152,
                "width": 47.14143345564036,
                "height": 37.417449382711474
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Palmieri_mortadella_Favola_cotenna_1495124184_1529687251.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/piatto_mortadella_pam_1535464739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_dB94Wyg_DdmVpGl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130093",
              "field1": "golfera",
              "field2": "salame di prosciutto golfetta",
              "field3": "l'etto",
              "field4": "",
              "description": "golfera salame di prosciutto golfetta l'etto",
              "grammage": 100,
              "price": "1.59",
              "price_label": "€ 1,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.16097499696006,
                "left": 1.7054122572796515,
                "width": 24.5281162089785,
                "height": 20.12530697299068
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/GOLFETTA_BT_interometa_1600348825.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_TurDCRg_0G5Ljrz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140755",
              "field1": "levoni",
              "field2": "salame milano",
              "field3": "l'etto",
              "field4": "",
              "description": "levoni salame milano l'etto",
              "grammage": 100,
              "price": "1.99",
              "price_label": "€ 1,99 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.16097499696006,
                "left": 26.23352846625815,
                "width": 23.798678751097043,
                "height": 20.12530697299068
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/2416760000000_T70_1606321276.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Fette_Salame_1606321278.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Co4caZG_lwDExY9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230666",
              "field1": "san vincenzo",
              "field2": "nduja di spilinga piccante",
              "field3": "l'etto",
              "field4": "",
              "description": "san vincenzo nduja di spilinga piccante l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.16097499696006,
                "left": 50.03220721735519,
                "width": 23.79866038545324,
                "height": 20.12530697299068
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SAN_VINCENZO_Nduja_di_Spilinga_2kg_1606321048.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_b4Xx05Y_9D2M4I8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165857",
              "field1": "veroni",
              "field2": "salame felino igp",
              "field3": "l'etto",
              "field4": "",
              "description": "veroni salame felino igp l'etto",
              "grammage": 100,
              "price": "2.29",
              "price_label": "€ 2,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 39.16097499696006,
                "left": 73.83086760280842,
                "width": 23.707493329598172,
                "height": 20.12530697299068
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Veroni_Felino_1542120806.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/salame_felino_tagliere_1430238144_1565187589_1574691880.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Logo_IGP_1606141817.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_C086Wrl_a6l3u9g.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197454",
              "field1": "san vincenzo",
              "field2": "-soppressata •dolce •piccante",
              "field3": "-spianata piccante",
              "field4": " l'etto",
              "description": "san vincenzo -soppressata •dolce •piccante -spianata piccante  l'etto",
              "grammage": 100,
              "price": "1.49",
              "price_label": "€ 1,49 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Soppressata dolce",
                "Soppressata piccante",
                "Spianata piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.28628196995073,
                "left": 73.83086760280842,
                "width": 23.707493329598172,
                "height": 38.687495963931134
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SAN_VINCENZO_Spianata_pic_1606321185.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/2316620000000_T1_1606321672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JE9GDgH_QWCNZBV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "232952",
              "field1": "bisanzio ",
              "field2": "pancetta arrotolata magretta oro ",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio  pancetta arrotolata magretta oro  l'etto",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.28628196995073,
                "left": 50.03220109547392,
                "width": 23.798666507334502,
                "height": 19.24605833491686
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Pancetta_magretta_1600764170.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_soFIEeq_u8mgvi2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130240",
              "field1": "capocollo",
              "field2": "di martina franca",
              "field3": "l'etto",
              "field4": "",
              "description": "capocollo di martina franca l'etto",
              "grammage": 100,
              "price": "2.19",
              "price_label": "€ 2,19 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.28628196995073,
                "left": 26.14234916664055,
                "width": 23.88985192883338,
                "height": 19.24605833491686
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Capocollo_Dolce-Piccante_al_Kg_1535385352.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Capocollo_di_Martina_Franca_RE_DELLA_VALLE_1605784618.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1XV7bOX_3jsvg6l.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134688",
              "field1": "levoni ",
              "field2": "salsiccia napoli ",
              "field3": "gr. 400 circa l'etto",
              "field4": "-dolce -forte",
              "description": "levoni  salsiccia napoli  gr. 400 circa l'etto -dolce -forte",
              "grammage": 100,
              "price": "1.79",
              "price_label": "€ 1,79 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Dolce",
                "Forte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.28628196995073,
                "left": 1.8877677955742282,
                "width": 24.25458137106632,
                "height": 19.24605833491686
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/levoni_salsiccia_napoli_dolce_1535389765.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_b4i5X3n_QzpdnOI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216394",
              "field1": "bisanzio",
              "field2": "guanciale al pepe",
              "field3": "l'etto",
              "field4": "",
              "description": "bisanzio guanciale al pepe l'etto",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 78.5323403048676,
                "left": 1.8877677955742282,
                "width": 24.25458137106632,
                "height": 19.636823482270195
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Guanciale_ambientato_1488206147_1522318641_1594138585.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_nIYoNTw_5gLvFnI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239416",
              "field1": "medusa",
              "field2": "frittura marinata vaschetta",
              "field3": "gr. 150",
              "field4": "",
              "description": "medusa frittura marinata vaschetta gr. 150",
              "grammage": 150,
              "price": "2.29",
              "price_label": "€ 2,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 78.5323403048676,
                "left": 26.14234916664055,
                "width": 24.07221664994986,
                "height": 19.636823482270195
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/23TA_Frittura_1605893592.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_V30KOZy_SQTY2bw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130242",
              "field1": "dilecce",
              "field2": "olive",
              "field3": "-verdi dolci bella cerignola -nere leccino",
              "field4": "l'etto",
              "description": "dilecce olive -verdi dolci bella cerignola -nere leccino l'etto",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59 l'etto",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "etto/i",
              "varieties": [
                "Verdi",
                "Nere"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.5323403048676,
                "left": 50.214565816590394,
                "width": 23.707487207716895,
                "height": 19.636823482270195
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DILECCE_OLIVE_BELLA_DI_CERIGNOLA_1564141216.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/olive_nere_leccino_1603266239.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yM4dOv8_vNYxjVJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 10,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0010_hfxcHt3.jpg",
          "products": [
            {
              "item_id": "133969",
              "field1": "rana",
              "field2": "rustici pasta ripiena",
              "field3": "gr. 250",
              "field4": "-cappelletti al prosciutto crudo -tortellini alla carne -tortelloni ricotta&spinaci",
              "description": "rana rustici pasta ripiena gr. 250 -cappelletti al prosciutto crudo -tortellini alla carne -tortelloni ricotta&spinaci",
              "grammage": 250,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cappeòòetti al prosciutto",
                "Tortellini alla carne",
                "Tortelloni ricotta e spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 2.5260473804225176,
                "width": 47.41496829355253,
                "height": 57.54275471591252
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3._Rustici_Crudo4_1584706231_1588922623.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3d-rustici-carne_1581408839_1588922701.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JP9WdFz_qFh4gBf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165888",
              "field1": "aia",
              "field2": "cappone tradizionale di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia cappone tradizionale di natale al kg",
              "grammage": null,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 49.94101567397505,
                "width": 23.707484146776267,
                "height": 18.073697301271842
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cappone_1543315853.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JZNrRAI_HsevRKO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165891",
              "field1": "aia",
              "field2": "tacchinella leggera di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia tacchinella leggera di natale al kg",
              "grammage": null,
              "price": "6.90",
              "price_label": "€ 6,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 73.64849982075133,
                "width": 23.79866344639387,
                "height": 18.073697301271842
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/tacchinella_1543316183.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_WUN997q_la41NIF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165890",
              "field1": "aia",
              "field2": "pollo eviscerato tradizionale di natale",
              "field3": "al kg",
              "field4": "",
              "description": "aia pollo eviscerato tradizionale di natale al kg",
              "grammage": null,
              "price": "3.50",
              "price_label": "€ 3,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 19.91491830183282,
                "left": 73.64849982075133,
                "width": 23.79866344639387,
                "height": 19.73453034710997
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/eviscerato_1543316099.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_0ZpftqB_haE6yBg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165889",
              "field1": "aia",
              "field2": "faraona",
              "field3": "al kg",
              "field4": "",
              "description": "aia faraona al kg",
              "grammage": null,
              "price": "5.50",
              "price_label": "€ 5,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 19.91491830183282,
                "left": 50.03219497359265,
                "width": 23.616304847158663,
                "height": 19.73453034710997
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/faraona_1543315930.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_9eOweLU_E4pg3eU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137275",
              "field1": "bovino",
              "field2": "pancia con osso",
              "field3": "al kg",
              "field4": "",
              "description": "bovino pancia con osso al kg",
              "grammage": 0,
              "price": "5.90",
              "price_label": "€ 5,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 39.649448648942794,
                "left": 50.03219497359265,
                "width": 23.616304847158663,
                "height": 19.539133015326673
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pancia_con_osso_PAM_1590685052.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_SWtvgkH_IFmnUel.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239425",
              "field1": "odori ",
              "field2": "per brodo e bollitto",
              "field3": "gr. 500",
              "field4": "",
              "description": "odori  per brodo e bollitto gr. 500",
              "grammage": 500,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.649448648942794,
                "left": 73.64849982075133,
                "width": 23.25129379838735,
                "height": 19.539133015326673
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/odori_1606320620.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_OgtKClL_N0HOM48.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139417",
              "field1": "pollo",
              "field2": "sovracosce intere",
              "field3": "al kg",
              "field4": "",
              "description": "pollo sovracosce intere al kg",
              "grammage": null,
              "price": "3.50",
              "price_label": "€ 3,50 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 59.188581664269456,
                "left": 50.21456275564976,
                "width": 46.685230863488904,
                "height": 18.95296397703154
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Sovracosce_di_Pollo_Cliente_1_1535465736_1536910282.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_PFGoQnS_WGriz16.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162501",
              "field1": "vitello",
              "field2": "fettine scelte",
              "field3": "al kg",
              "field4": "",
              "description": "vitello fettine scelte al kg",
              "grammage": 0,
              "price": "11.90",
              "price_label": "€ 11,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 59.188581664269456,
                "left": 2.890492155176467,
                "width": 47.3240706004733,
                "height": 18.95296397703154
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/fettine_vitello_pam_1540213819_1581954710.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_dx7Mvkm_yNQkvEs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133884",
              "field1": "bovino",
              "field2": "macinato scelto",
              "field3": "al kg",
              "field4": "",
              "description": "bovino macinato scelto al kg",
              "grammage": 0,
              "price": "6.90",
              "price_label": "€ 6,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 78.141545641301,
                "left": 2.890492155176467,
                "width": 31.64065560940635,
                "height": 20.223007278671954
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Macinato_di_Bovino_Adulto_Cliente_1_1535450999.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_vE5Fya1_unYhYwV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132725",
              "field1": "gusto ricco",
              "field2": "cotolette pollo",
              "field3": "x 8 - gr. 800",
              "field4": "-classiche -spinaci",
              "description": "gusto ricco cotolette pollo x 8 - gr. 800 -classiche -spinaci",
              "grammage": 800,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classiche",
                "Spinaci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.141545641301,
                "left": 34.53114776458281,
                "width": 31.275362954096668,
                "height": 20.223007278671954
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Gustoricco_Cotoletta-pollox8_g800_1535450940_1550567983_1555408522.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/GustoriccoCotolettapollox8g800_1548955983_1550567795_1555408523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_vEJ8oq8_1wmvvXz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165886",
              "field1": "martini ",
              "field2": "i gustorolli gr. 650  ",
              "field3": "di pollo -speck&formaggio",
              "field4": "di suino -spinaci&parmigiano -antichi sapori ",
              "description": "martini  i gustorolli gr. 650   di pollo -speck&formaggio di suino -spinaci&parmigiano -antichi sapori ",
              "grammage": 650,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pollo speck e formaggio",
                "Suino spinaci e parmigiano",
                "Antichi sapori"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.141545641301,
                "left": 65.80651071867948,
                "width": 31.549470187907477,
                "height": 20.223007278671954
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MARTINI_I_GUSTOROLLI_GR.650_1542121414.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MARTINI_I_GUSTOROLLI_DI_SUINO_GR.650_SPINACIPARM_1551721301.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_HtjUCQp_091Cmxq.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 11,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0011_pJASHVI.jpg",
          "products": [
            {
              "item_id": "141809",
              "field1": "suino",
              "field2": "arrosto in rete",
              "field3": "al kg",
              "field4": "",
              "description": "suino arrosto in rete al kg",
              "grammage": 0,
              "price": "6.90",
              "price_label": "€ 6,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 2.0366084936065216,
                "left": 56.77971414242728,
                "width": 40.21125877632899,
                "height": 17.878309808226298
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/suino_pam_prova_1539696926_1554207269.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_UoIhjzm_TOp3OtV.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165895",
              "field1": "bovino",
              "field2": "polpa per arrosto",
              "field3": "al kg",
              "field4": "",
              "description": "bovino polpa per arrosto al kg",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Bovino",
              "blueprint": {
                "top": 19.91491830183282,
                "left": 56.77971414242728,
                "width": 40.21125877632899,
                "height": 20.223007278671954
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/bovino_arrosto_1542992993.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_lmvDPyu_yCvV7uS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166834",
              "field1": "avimecc ",
              "field2": "rollè di pollo",
              "field3": "vaschetta gr. 800 circa",
              "field4": " al kg",
              "description": "avimecc  rollè di pollo vaschetta gr. 800 circa  al kg",
              "grammage": 0,
              "price": "6.99",
              "price_label": "€ 6,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 40.13792558050477,
                "left": 65.80679538615847,
                "width": 31.184177532597793,
                "height": 19.34374224270188
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/AVIMECC_ROLLEDI_POLLO_CONFEZIONATO_GR.800_CIRCA_1542639204.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_wj1DCRS_A3SQgMW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239424",
              "field1": "avimecc",
              "field2": "pollo ripieno",
              "field3": "gr. 1100 circa",
              "field4": "al kg",
              "description": "avimecc pollo ripieno gr. 1100 circa al kg",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 40.13792558050477,
                "left": 34.16613977675213,
                "width": 31.64065560940635,
                "height": 19.34374224270188
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/foto_pollo_ripieno_1606293985.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_k3fE5Au_oY9Nhd1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239423",
              "field1": "aia fuoco",
              "field2": "salsiccia paesana di suino x2 rotoli",
              "field3": "gr. 380",
              "field4": "",
              "description": "aia fuoco salsiccia paesana di suino x2 rotoli gr. 380",
              "grammage": 380,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Suino",
              "blueprint": {
                "top": 40.13792558050477,
                "left": 2.799597523037863,
                "width": 31.366542253714268,
                "height": 19.34374224270188
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/principale_8008110270186_1605715246.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_96HZ8bf_XNqUlsX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197360",
              "field1": "amadori",
              "field2": "fesa di tacchino 10+ fette",
              "field3": "x 3 gr. 300 circa",
              "field4": "al kg",
              "description": "amadori fesa di tacchino 10+ fette x 3 gr. 300 circa al kg",
              "grammage": 0,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Avicoli",
              "blueprint": {
                "top": 59.48166782320664,
                "left": 2.799597523037863,
                "width": 31.366542253714268,
                "height": 18.95296561682117
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/16551_Tacchino_Fesa_Fette_10_rt_1568638525_1573484340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_RMHtrCw_ZcuituY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131572",
              "field1": "amadori",
              "field2": "salsicce ricetta classica",
              "field3": "x 6",
              "field4": "gr. 430",
              "description": "amadori salsicce ricetta classica x 6 gr. 430",
              "grammage": 430,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.43463344002781,
                "left": 2.799597523037863,
                "width": 31.366542253714268,
                "height": 19.83221753447424
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/amadori_salsicce_pollo_e_tacchino_x_6_g430_1552665511.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_fN0HhA3_aIGfoOY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165896",
              "field1": "agnello",
              "field2": "intero/metà",
              "field3": "con testa e corata",
              "field4": "al kg",
              "description": "agnello intero/metà con testa e corata al kg",
              "grammage": null,
              "price": "9.90",
              "price_label": "€ 9,90 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Macelleria",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.38397735626312,
                "left": 34.16613977675213,
                "width": 62.916300170041374,
                "height": 38.882873618238925
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/agnello_taglio_misto_1541418391_1574684337.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_E2GB2nI_ObGensU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 12,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0012_eFY7ubd.jpg",
          "products": [
            {
              "item_id": "189921",
              "field1": "mele golden",
              "field2": "",
              "field3": "al kg",
              "field4": "",
              "description": "mele golden al kg",
              "grammage": null,
              "price": "1.19",
              "price_label": "€ 1,19 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 9.363788703670306,
                "left": 2.7081304950006273,
                "width": 37.65870977189381,
                "height": 30.187961279380833
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/mela_golden_1536942795_1568626510.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_TGlg0rb_OHqmMsw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131266",
              "field1": "ananas",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "ananas al kg",
              "grammage": 0,
              "price": "1.29",
              "price_label": "€ 1,29 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 1.7435256142485815,
                "left": 40.366840266894435,
                "width": 19.148075329504138,
                "height": 19.929912920786634
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ananas_singola_pam_1539676692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ananas_aperta_shutter_1574095197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mmEarih_LV8Ynq1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170390",
              "field1": "arance tarocco",
              "field2": "confezione",
              "field3": "kg. 1,5",
              "field4": "",
              "description": "arance tarocco confezione kg. 1,5",
              "grammage": 1500,
              "price": "2.38",
              "price_label": "€ 2,38",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 1.7435256142485815,
                "left": 59.51491559639858,
                "width": 38.75289197671139,
                "height": 19.929912920786634
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/arance_navel_tarocco_1487256171_1487687804_1545929892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/arance_tarocco_rete_1546859632.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_sjMf5Fy_kQmacYr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131267",
              "field1": "uva  ",
              "field2": "red globe",
              "field3": "al kg",
              "field4": "",
              "description": "uva   red globe al kg",
              "grammage": 0,
              "price": "2.29",
              "price_label": "€ 2,29 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 21.673438535035217,
                "left": 40.731569709127385,
                "width": 18.78334588727119,
                "height": 17.68292395497038
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/uva_red_globe_1471350509_1471603655_1505125375_1606124996.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_H6W7j6n_JvF5gll.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132337",
              "field1": "melone",
              "field2": "giallo",
              "field3": "al kg",
              "field4": "",
              "description": "melone giallo al kg",
              "grammage": 0,
              "price": "1.39",
              "price_label": "€ 1,39 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 21.673438535035217,
                "left": 59.51491559639858,
                "width": 19.057446999200728,
                "height": 17.68292395497038
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Melone_di_pane_giallo_1428426467_1471603674_1535387058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_VKP3B9S_fTzCZ0j.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239908",
              "field1": "cipolla",
              "field2": "rossa confezione",
              "field3": "gr. 750",
              "field4": "",
              "description": "cipolla rossa confezione gr. 750",
              "grammage": 750,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 21.673438535035217,
                "left": 78.5723625955993,
                "width": 19.877534213970037,
                "height": 17.68292395497038
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cipolla_rossa_1606328126.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_HmHbjUx_ESDoi0x.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137268",
              "field1": "bonduelle",
              "field2": "insalata iceberg",
              "field3": "gr. 200",
              "field4": "",
              "description": "bonduelle insalata iceberg gr. 200",
              "grammage": 200,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.3563624900056,
                "left": 78.5723625955993,
                "width": 19.877534213970037,
                "height": 19.53912645616817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/insalata_iceberg_piatto_1535385523.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8006862005360_T5_1606404667.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_BjxpLoi_0PrQmJc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185294",
              "field1": "pam",
              "field2": "insalata mista",
              "field3": "formato convenienza busta gr. 400",
              "field4": "",
              "description": "pam insalata mista formato convenienza busta gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.3563624900056,
                "left": 59.514909474517296,
                "width": 19.057453121081995,
                "height": 19.53912645616817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260766_PAM_INSALATA_MISTA_MAXI_GR.400_1594732248.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_oSUmC5y_6BNEJef.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "184541",
              "field1": "pam",
              "field2": "insalata valeriana",
              "field3": "busta gr. 200",
              "field4": "",
              "description": "pam insalata valeriana busta gr. 200",
              "grammage": 200,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.3563624900056,
                "left": 40.640384287628514,
                "width": 18.874525186888793,
                "height": 19.53912645616817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8004263520031_T5_1600339087.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_gri14E7_TmGqf8u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "219014",
              "field1": "funghi champignons",
              "field2": "affettato",
              "field3": "vaschetta",
              "field4": "gr. 300",
              "description": "funghi champignons affettato vaschetta gr. 300",
              "grammage": 300,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.3563624900056,
                "left": 21.76529588766299,
                "width": 18.875088399965524,
                "height": 19.53912645616817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Funghi_Champignon_Tagliati_vaschetta_1453298241_1573035750_1596807737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JfXLMre_IeyTbkO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202821",
              "field1": "pomodoro ciliegino",
              "field2": "gr. 500",
              "field3": "",
              "field4": "",
              "description": "pomodoro ciliegino gr. 500",
              "grammage": 500,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 39.3563624900056,
                "left": 2.617223619099489,
                "width": 19.148072268563503,
                "height": 19.53912645616817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pomodori_ciliegino_vaschetta_carrefour_1428569690_1453884677_1503578_pm3Ao7s.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_DI48syA_IwQqHPn.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141466",
              "field1": "finocchio",
              "field2": "al kg",
              "field3": "",
              "field4": "",
              "description": "finocchio al kg",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99 al Kg",
              "equivalence": 1000,
              "quantity_step": 100,
              "grocery_label": "gr.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Verdura",
              "blueprint": {
                "top": 58.895488946173764,
                "left": 2.617223619099489,
                "width": 37.84050821899292,
                "height": 39.56676263969084
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/finocchio_DOK_1427206958_1588756920.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_xh1LVtT_QkwPsKZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239909",
              "field1": "datteri",
              "field2": "kenta",
              "field3": "gr. 200",
              "field4": "",
              "description": "datteri kenta gr. 200",
              "grammage": 200,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 58.895488946173764,
                "left": 40.45773183809241,
                "width": 19.23982396407974,
                "height": 39.56676263969084
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4077_DATTERI_KENTA_BF_25X200G_GOND_6194001160215_1606294058.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_u5v39U2_BvBgIp0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "231268",
              "field1": "pam",
              "field2": "uva sultanina",
              "field3": "busta",
              "field4": "gr. 250",
              "description": "pam uva sultanina busta gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 71.59592852173638,
                "left": 59.69755580217214,
                "width": 16.868494888963767,
                "height": 26.866323064128213
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8004263669853_1598953242.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_qm67jdm_6H56sLU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239910",
              "field1": "misto frutta secca",
              "field2": "gr. 400",
              "field3": "",
              "field4": "",
              "description": "misto frutta secca gr. 400",
              "grammage": 400,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Ortofrutta",
              "subcategory": "Frutta",
              "blueprint": {
                "top": 71.59592852173638,
                "left": 76.56605069113591,
                "width": 20.97230411938942,
                "height": 26.866323064128213
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Misto_frutta_secca_gr._400_2_1606294025.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_k21TrnR_xlwdejT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 13,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0013_HcagTXF.jpg",
          "products": [
            {
              "item_id": "134743",
              "field1": "findus ",
              "field2": "pisellini primavera",
              "field3": "gr. 750",
              "field4": "",
              "description": "findus  pisellini primavera gr. 750",
              "grammage": 750,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 9.168393011676637,
                "left": 1.5501031904306672,
                "width": 28.05718179930416,
                "height": 31.45800950039012
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pisellini_primavera_750g_1_1580738822.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_nQuKKcq_5jyOVpX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137307",
              "field1": "dal peschereccio ",
              "field2": "misto per risotto&spaghetti ",
              "field3": "gr. 250",
              "field4": "",
              "description": "dal peschereccio  misto per risotto&spaghetti  gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 9.168393011676637,
                "left": 29.60728498973483,
                "width": 29.75260926823439,
                "height": 31.45800950039012
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/dal_peschereccio_misto_psgahetti_e_risotti_1588066449.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_5Pk23T0_YomGyNK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134742",
              "field1": "findus",
              "field2": "ciuffetti di spinaci primavera",
              "field3": "gr. 450",
              "field4": "",
              "description": "findus ciuffetti di spinaci primavera gr. 450",
              "grammage": 450,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 1.7435206948797048,
                "left": 59.35989425796922,
                "width": 18.75654735201699,
                "height": 20.02761650604716
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SPINACI_CIUFFETTI_450G_1600856065.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_GNGDTQ5_EIdI5j1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197272",
              "field1": "petrucci",
              "field2": "funghi misti con porcini",
              "field3": "kg. 1",
              "field4": "",
              "description": "petrucci funghi misti con porcini kg. 1",
              "grammage": 0,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 1.7435206948797048,
                "left": 78.1164416099862,
                "width": 19.08424553445493,
                "height": 20.02761650604716
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/funghi_misto_bosco_con_porcini_1kg_1513268183_1573470829.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_aKACDEd_UaIVsI8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140783",
              "field1": "aia",
              "field2": "cotolette di pollo",
              "field3": "surgelate",
              "field4": "gr. 280",
              "description": "aia cotolette di pollo surgelate gr. 280",
              "grammage": 280,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 21.771137200926866,
                "left": 78.1164416099862,
                "width": 19.08424553445493,
                "height": 18.757569924827497
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Aia_3_cotolette_filetti_pollo_280_g_1536576626.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_twVODrm_cTAaTdE.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133906",
              "field1": "pizzoli",
              "field2": "patatine we love rustiche",
              "field3": "gr. 750",
              "field4": "",
              "description": "pizzoli patatine we love rustiche gr. 750",
              "grammage": 750,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Verdure",
              "blueprint": {
                "top": 21.771137200926866,
                "left": 59.451073557586824,
                "width": 18.665368052399387,
                "height": 18.757569924827497
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Pizzoli_We_Love_Rustiche_Allegre_Casalinghe_750_g_1579533798_1596212919.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yZ4TDp2_Sv0k30r.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137308",
              "field1": "findus ",
              "field2": "fiori merluzzo ",
              "field3": "x 4",
              "field4": "gr. 300",
              "description": "findus  fiori merluzzo  x 4 gr. 300",
              "grammage": 300,
              "price": "4.89",
              "price_label": "€ 4,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 1.6142115310776077,
                "width": 19.9960691400373,
                "height": 18.6598745385151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/findus_fiori_di_merluzzo_1600245077_1600339166.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ORuNBZs_ZE7mTgN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230675",
              "field1": "capitan findus",
              "field2": "bastoncini di merluzzo",
              "field3": "x 18",
              "field4": "gr. 450",
              "description": "capitan findus bastoncini di merluzzo x 18 gr. 450",
              "grammage": 450,
              "price": "3.79",
              "price_label": "€ 3,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 21.610280671114907,
                "width": 18.93891819501473,
                "height": 18.6598745385151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/64247-16291-46816_1600758455.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_UHWPdrH_4RkvDB2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197271",
              "field1": "vento di mare",
              "field2": "gamberi sgusciati precotti",
              "field3": "gr. 400",
              "field4": "",
              "description": "vento di mare gamberi sgusciati precotti gr. 400",
              "grammage": 400,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 40.549198866129636,
                "width": 18.901874691457184,
                "height": 18.6598745385151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/vento_di_mare_1573485998.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_H5DT0CG_tLhi40d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133916",
              "field1": "frescofiore ",
              "field2": "panzerottini da friggere ",
              "field3": "gr. 500",
              "field4": "",
              "description": "frescofiore  panzerottini da friggere  gr. 500",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 59.451073557586824,
                "width": 19.030103616513603,
                "height": 18.6598745385151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/IMG_20180727_105200_1535451283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_vW9Lr9L_y9D1XV8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141818",
              "field1": "soavegel",
              "field2": "mozzarelline panate",
              "field3": "gr. 250",
              "field4": "",
              "description": "soavegel mozzarelline panate gr. 250",
              "grammage": 250,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Panati",
              "blueprint": {
                "top": 40.528707125754366,
                "left": 78.48117717410042,
                "width": 18.901868569575914,
                "height": 18.6598745385151
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Soavegel_Mozzarelline_250_g_1587488427.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_O7PKXHZ_PdilRDL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131654",
              "field1": "tutta natura ",
              "field2": "sorbetto x 4 flutes ",
              "field3": "gr. 260",
              "field4": "-limonetto -caffè",
              "description": "tutta natura  sorbetto x 4 flutes  gr. 260 -limonetto -caffè",
              "grammage": 260,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Limonetto",
                "Caffè"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 59.188581664269456,
                "left": 78.48117717410042,
                "width": 18.901868569575914,
                "height": 18.85526695092952
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TUTTA_NATURA_SORBETTO_LIMONETTO_x_4_g260_1530893390.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Z1Tsneb_5IYb4fb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134736",
              "field1": "sammontana\t",
              "field2": "torta gelato st. honorè",
              "field3": "gr. 750",
              "field4": "",
              "description": "sammontana\t torta gelato st. honorè gr. 750",
              "grammage": 750,
              "price": "4.79",
              "price_label": "€ 4,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Dolci",
              "blueprint": {
                "top": 59.188581664269456,
                "left": 59.45106743570555,
                "width": 19.030109738394874,
                "height": 18.85526695092952
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SAMMONTANA_TORTA_GELATO_ST.HONORE_GR.750_1554197407.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_W3BkRXC_Cnw2Y73.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130318",
              "field1": "magnum",
              "field2": "bomboniera",
              "field3": "x 12 - gr. 104",
              "field4": "-classic -classic almond white -caffè",
              "description": "magnum bomboniera x 12 - gr. 104 -classic -classic almond white -caffè",
              "grammage": 104,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classic",
                "Classic almond white",
                "Caffè"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 78.04384861519897,
                "left": 59.45106743570555,
                "width": 37.9049226537033,
                "height": 19.806846326769787
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/algida_magnum_bomboniera_classica_1495097234_1495880317_1508238974_1_tkaNnJ7.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/algida_magnum_bomboniera_classic_almond_white_1495097233_1495880317__MKwQ8qJ.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_BBkqqug_E7Ussyl.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239426",
              "field1": "sammontana",
              "field2": "barattolino",
              "field3": "spirito natalizio ",
              "field4": "gr. 410",
              "description": "sammontana barattolino spirito natalizio  gr. 410",
              "grammage": 410,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Gelati",
              "blueprint": {
                "top": 59.57936484930867,
                "left": 33.61932721994107,
                "width": 25.831740215764484,
                "height": 38.271330092660094
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/64212_1604478560_1605715791.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_MzVAh3k_ezjzZLJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165898",
              "field1": "gamberi",
              "field2": "argentini",
              "field3": "gr. 400",
              "field4": "",
              "description": "gamberi argentini gr. 400",
              "grammage": 400,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Surgelati",
              "subcategory": "Ittico",
              "blueprint": {
                "top": 59.57936484930867,
                "left": 1.7324556677846037,
                "width": 31.886871552156467,
                "height": 38.271330092660094
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/vento_di_mare_GAMBERI_ARGENTINI_G400_1542047030.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_r2QOh5Z_QP5UDX4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 14,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0014_YLjJooc.jpg",
          "products": [
            {
              "item_id": "131728",
              "field1": "rana",
              "field2": "lasagne all'uovo sfogliagrezza",
              "field3": "gr. 250",
              "field4": "",
              "description": "rana lasagne all'uovo sfogliagrezza gr. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 8.973005518631092,
                "left": 3.009008715599925,
                "width": 19.94194252679915,
                "height": 31.530327119839566
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Rana_Lasagne_Sfogliagrezza_1544035954_1544202777_1549279644_15496180_vpr8B0U.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_pprOnNG_b5f5O3a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215573",
              "field1": "veroni",
              "field2": "fette prosciutto crudo ",
              "field3": "vaschetta gr. 80",
              "field4": "",
              "description": "veroni fette prosciutto crudo  vaschetta gr. 80",
              "grammage": 80,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 8.973005518631092,
                "left": 22.95095124239907,
                "width": 17.35175313538271,
                "height": 31.530327119839566
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/N220F-1_1593017922.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_8hZWAmV_crTl2q3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132561",
              "field1": "zappalà",
              "field2": "mozzarelle tris",
              "field3": "gr. 300",
              "field4": "",
              "description": "zappalà mozzarelle tris gr. 300",
              "grammage": 300,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 40.30270437778179,
                "width": 19.303666002891486,
                "height": 19.904541713082185
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/latterie_di_zappala_mozzarelle_tris_g300_1532338932.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1qYUIGe_CbVKZrD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137320",
              "field1": "certosino",
              "field2": "crescenza",
              "field3": "gr. 100",
              "field4": "",
              "description": "certosino crescenza gr. 100",
              "grammage": 100,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 59.60637038067326,
                "width": 18.719491604696906,
                "height": 19.904541713082185
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Certosa_100_1531739923_1532623951_1533725395.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mcWiRRS_4pWjm1U.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134765",
              "field1": "galbani",
              "field2": "galbanino formaggio dolce",
              "field3": "gr. 550",
              "field4": "",
              "description": "galbani galbanino formaggio dolce gr. 550",
              "grammage": 550,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 1.8412210005609788,
                "left": 78.32586198537018,
                "width": 19.85076628812218,
                "height": 19.904541713082185
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/galbanino_1574845320_1575905599_1584604530.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ajsLcJz_hItQQgY.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170717",
              "field1": "parmareggio",
              "field2": "parmigiano reggiano petali",
              "field3": "gr. 80",
              "field4": "",
              "description": "parmareggio parmigiano reggiano petali gr. 80",
              "grammage": 80,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.745762713643163,
                "left": 78.32586198537018,
                "width": 19.85076628812218,
                "height": 18.782947691690445
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1583422424_812042-0010-petali-parmareggio-100g_1593685120_1595319197.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_nRVqxC0_pvBD1B4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170685",
              "field1": "gran soresina",
              "field2": "grana padano",
              "field3": "oltre 16 mesi",
              "field4": "gr. 200",
              "description": "gran soresina grana padano oltre 16 mesi gr. 200",
              "grammage": 200,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.745762713643163,
                "left": 59.60637038067326,
                "width": 18.719491604696906,
                "height": 18.782947691690445
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Grana_Padano_Gran_Soresina_16M_200_gr_1540915752.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_s92PakC_TfPB7bD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130330",
              "field1": "santa lucia galbani",
              "field2": "mascarpone",
              "field3": "gr. 500",
              "field4": "",
              "description": "santa lucia galbani mascarpone gr. 500",
              "grammage": 500,
              "price": "3.89",
              "price_label": "€ 3,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 21.745762713643163,
                "left": 40.39388367739939,
                "width": 19.212486703273882,
                "height": 18.782947691690445
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Mascarpone_Santa_Lucia_500g_1478248975.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_f4sNGL8_VXg2S8w.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134779",
              "field1": "parmareggio",
              "field2": "burro",
              "field3": "gr. 200",
              "field4": "",
              "description": "parmareggio burro gr. 200",
              "grammage": 200,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 40.52871040533361,
                "left": 2.8907707007741976,
                "width": 18.719491604696906,
                "height": 18.732192157964548
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/447025_parmareggio_BURRO_200g_1563528313_1573492800.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_sU8GnlV_sKP2JW6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "218453",
              "field1": "san vincenzo",
              "field2": "coppia",
              "field3": "spianata+provola fette",
              "field4": "gr. 100",
              "description": "san vincenzo coppia spianata+provola fette gr. 100",
              "grammage": 100,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.52871040533361,
                "left": 21.6102623054711,
                "width": 18.938936560658536,
                "height": 18.732192157964548
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SAN_VINCENZO_coppia_spianata_e_provola_affettati_1596807179.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yeeHJra_XN3wu4P.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215574",
              "field1": "veroni",
              "field2": "fette prosciutto cotto",
              "field3": "alta qualità",
              "field4": "vaschetta gr. 80",
              "description": "veroni fette prosciutto cotto alta qualità vaschetta gr. 80",
              "grammage": 80,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.52871040533361,
                "left": 40.549198866129636,
                "width": 18.901856325813377,
                "height": 18.732192157964548
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/N362F-1_1593018089.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_EvPngIl_SAbqUIw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215552",
              "field1": "bisanzio",
              "field2": "pancetta cubetti",
              "field3": "-dolce -affumicata",
              "field4": "gr. 100",
              "description": "bisanzio pancetta cubetti -dolce -affumicata gr. 100",
              "grammage": 100,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Dolce",
                "Affumicata"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.52871040533361,
                "left": 59.45105519194301,
                "width": 18.756565717660795,
                "height": 18.732192157964548
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/bisanzio_Carbonara_Pancetta_affumicata_a_cubetti_100_g_1593679772.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/bisanzio_Pancetta_dolce_a_cubetti_100_g_1593679773.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_tVNSjGn_MzQGBk3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137337",
              "field1": "negroni ",
              "field2": "cotto in cubetti",
              "field3": "gr. 120",
              "field4": "",
              "description": "negroni  cotto in cubetti gr. 120",
              "grammage": 120,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.52871040533361,
                "left": 78.20762090960382,
                "width": 19.904877596657162,
                "height": 18.732192157964548
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/86504_Cubetti_Prosciutto_Cotto_120g_2018_rifl_1550231181.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_KEmLZii_idZCEO4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "178415",
              "field1": "beretta",
              "field2": "wurstel classici di suino",
              "field3": "x 4 - gr.100",
              "field4": "",
              "description": "beretta wurstel classici di suino x 4 - gr.100",
              "grammage": 100,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.26090256329815,
                "left": 78.20762090960382,
                "width": 19.904877596657162,
                "height": 18.7829509712697
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Beretta_4_wurstel_classici_100_g.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_wT9QUi6_fcR3M25.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131709",
              "field1": "aia wudy ",
              "field2": "wurstel con formaggio ",
              "field3": "x 3 - gr. 150",
              "field4": "",
              "description": "aia wudy  wurstel con formaggio  x 3 - gr. 150",
              "grammage": 150,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.26090256329815,
                "left": 59.35988201420668,
                "width": 18.84773889539713,
                "height": 18.7829509712697
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Aia_Wudy_wurstel_formaggio_150_g_1537377280_1537377306_1554972732_1576148614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_8ImAuBo_7lZNkSH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "212158",
              "field1": "clai",
              "field2": "salametto golosetto in busta",
              "field3": "gr. 100",
              "field4": "",
              "description": "clai salametto golosetto in busta gr. 100",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 59.26090256329815,
                "left": 40.64037204386597,
                "width": 18.71950997034071,
                "height": 18.7829509712697
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CLAI_SALAME_GOLOSETTO_GR.100_1570210000_1588867794.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_AVXm7hd_E1IA8aB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239427",
              "field1": "soresina",
              "field2": "burro",
              "field3": "gr. 250",
              "field4": "",
              "description": "soresina burro gr. 250",
              "grammage": 250,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Gastronomia",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.26090256329815,
                "left": 22.43091273331714,
                "width": 18.209459310548834,
                "height": 38.58979237867061
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/principale_8004673220118_1604074462_1605715880.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_IjEOanX_JH11z4N.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131673",
              "field1": "gran soresina ",
              "field2": "grana padano grattugiato ",
              "field3": "gr. 200",
              "field4": "",
              "description": "gran soresina  grana padano grattugiato  gr. 200",
              "grammage": 200,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 59.26090256329815,
                "left": 2.5260320757193457,
                "width": 19.904880657597793,
                "height": 38.58979237867061
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Gran_Soresina_grana_dop_grattugiato_200_g_1436191883.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/gran_soresina_GRANA_PADANO_GRATTUGIATO_GR.200_1537354420.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_YaONYnt_D5QDlLw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185305",
              "field1": "pam",
              "field2": "pasta rotolo",
              "field3": "gr. 230",
              "field4": "-brisée -sfoglia",
              "description": "pam pasta rotolo gr. 230 -brisée -sfoglia",
              "grammage": 230,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Brisée",
                "Sfoglia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 78.21386326075044,
                "left": 40.48507522077953,
                "width": 19.03010667745424,
                "height": 19.63683168121832
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000517_PAM_PASTA_BRISEE_ROTOLO_G230_1563527196.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_zBYR4Ja_VLjVrc2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130095",
              "field1": "rana",
              "field2": "-pesto fresco gr. 140",
              "field3": "-sugo fresco gr. 180",
              "field4": "vari gusti",
              "description": "rana -pesto fresco gr. 140 -sugo fresco gr. 180 vari gusti",
              "grammage": 0,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pesto",
                "Sugo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Vegetali",
              "blueprint": {
                "top": 78.21386326075044,
                "left": 59.51518189823376,
                "width": 18.99305705201542,
                "height": 19.63683168121832
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/RANA_pesto_fresco_GENOVESE_140g_1488874245.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/RANA_NOCI_140_1486465025_1497516781_1587129542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Rana_Pesto_Senzaglio_DOP_140g_1578592200_1587129543.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_w99hnFV_BwGO5Sa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133970",
              "field1": "maffei",
              "field2": "pasta fresca di semola",
              "field3": "varie trafile",
              "field4": "gr. 450",
              "description": "maffei pasta fresca di semola varie trafile gr. 450",
              "grammage": 450,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 78.21386326075044,
                "left": 78.50823895024918,
                "width": 19.94192416115534,
                "height": 19.63683168121832
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1012860_CAVATELLI_IL_PASTAIO_500G_1520439413_1521563973_1597135535_1_653OhO0.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Maffei_Bari_Vecchia_500g_100_ITA_1520439417_1521563973_1597135535_1602494575.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_AlRIivG_1cIsocH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 15,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0015_wdcoGCL.jpg",
          "products": [
            {
              "item_id": "130357",
              "field1": "galbanella",
              "field2": "mortadellina",
              "field3": "gr. 430 ",
              "field4": "",
              "description": "galbanella mortadellina gr. 430 ",
              "grammage": 430,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 9.168393011676637,
                "left": 1.7053969525764794,
                "width": 38.934987335052035,
                "height": 16.510569480483863
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Galbanella_430_gr_con_ricette_1472142422_1472220203_1475222104_15585_KGKJZxG.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_AH63aPd_LAa7NAf.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134774",
              "field1": "parmareggio",
              "field2": "fettine al parmigiano reggiano",
              "field3": "gr. 150",
              "field4": "",
              "description": "parmareggio fettine al parmigiano reggiano gr. 150",
              "grammage": 150,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Formaggi",
              "blueprint": {
                "top": 25.6789624921605,
                "left": 1.7053969525764794,
                "width": 38.934987335052035,
                "height": 14.752049247281466
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/33582_ParmareggioFettine150gr_1573660568_1574096692.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_gwklF58_tgN2fPZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "197274",
              "field1": "pam",
              "field2": "uova fresche",
              "field3": "allevamento a terra medie",
              "field4": "x 10",
              "description": "pam uova fresche allevamento a terra medie x 10",
              "grammage": 0,
              "price": "1.75",
              "price_label": "€ 1,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.43101173944196,
                "left": 1.7053969525764794,
                "width": 19.8778158205084,
                "height": 18.95296397703154
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260607_pam_uova_allev.terra_medie_x_10_1573487493.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_jZ18xd1_Rxvfrt6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "192504",
              "field1": "citterio",
              "field2": "gli irresistibili",
              "field3": "salamini",
              "field4": "gr. 75",
              "description": "citterio gli irresistibili salamini gr. 75",
              "grammage": 75,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Salumi",
              "blueprint": {
                "top": 40.43101173944196,
                "left": 21.58321277308488,
                "width": 18.965989153985394,
                "height": 18.95296397703154
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cover-irresistibili-salaminilegno_1548062936_1570799675.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_84QEFTT_n1bjJ2T.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130340",
              "field1": "actimel ",
              "field2": "gr. 100 x 6",
              "field3": "vari gusti",
              "field4": "",
              "description": "actimel  gr. 100 x 6 vari gusti",
              "grammage": 600,
              "price": "2.39",
              "price_label": "€ 2,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 59.38397571647349,
                "left": 21.58321277308488,
                "width": 18.965989153985394,
                "height": 18.855265311139892
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Actimel_6x_bianco_1549293965_1554135338_1563814738.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Actimel_6x_fragola_1549293966_1554135339_1563814739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_21HYD8d_aJiwcFh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140873",
              "field1": "perugina",
              "field2": "nuvole dessert fresco",
              "field3": "gr. 60 x 4",
              "field4": "-cioccolato -fiordilatte",
              "description": "perugina nuvole dessert fresco gr. 60 x 4 -cioccolato -fiordilatte",
              "grammage": 240,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cioccolato",
                "Fiordilatte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Snack",
              "blueprint": {
                "top": 59.38397571647349,
                "left": 1.705400013517114,
                "width": 19.877812759567767,
                "height": 18.855265311139892
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/perugina_Nuvole_Fiordilatte_1519832525_1519832648.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/NUVOLE_CIOCCCOLATO_AL_LATTE_1568387931_1571676174_1589992901.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_zbvaVet_2ijdneg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131690",
              "field1": "granarolo",
              "field2": "yogurt cremoso alla frutta",
              "field3": "gr. 125 x 8",
              "field4": "",
              "description": "granarolo yogurt cremoso alla frutta gr. 125 x 8",
              "grammage": 0,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 78.23924102761339,
                "left": 1.887770856514857,
                "width": 13.495023032966087,
                "height": 20.223010558251207
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/AQ_Yog_FILIERA_x8_1574076567.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_AwI0ywm_pvnZlRd.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "191384",
              "field1": "milk",
              "field2": "kefir cremoso",
              "field3": "gr. 150",
              "field4": "-bianco dolce -mirtillo -avena e noci",
              "description": "milk kefir cremoso gr. 150 -bianco dolce -mirtillo -avena e noci",
              "grammage": 150,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Bianco dolce",
                "Mirtillo",
                "Avena e noci"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 78.23924102761339,
                "left": 15.382793889480945,
                "width": 12.583208610205617,
                "height": 20.223010558251207
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/60747_1562766269_1569580278.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MILK_KEFIR_CREM_MIRTILLO_GR150_1565109067_1569580323.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_kIfAJTm_UctoN2a.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131693",
              "field1": "mevgal ",
              "field2": "crema di yogurt greco bianco extra ",
              "field3": "gr. 150 ",
              "field4": "-classico -0%",
              "description": "mevgal  crema di yogurt greco bianco extra  gr. 150  -classico -0%",
              "grammage": 150,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "0%"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Yogurt",
              "blueprint": {
                "top": 78.23924102761339,
                "left": 27.966002499686564,
                "width": 12.765567209440823,
                "height": 20.223010558251207
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MEVGAL_BIANCO_g150_Extra-Extra_0_1531123579_1531130385.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Ou3Wbve_huNO58V.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130173",
              "field1": "heineken",
              "field2": "Birra",
              "field3": "cl. 66",
              "field4": "",
              "description": "heineken Birra cl. 66",
              "grammage": 660,
              "price": "1.00",
              "price_label": "€ 1,00",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 9.168393011676637,
                "left": 40.731569709127385,
                "width": 37.65843428723671,
                "height": 30.871835542726117
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/heineken_birra_66_cl.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4CNA47B_WPCdqh1.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137460",
              "field1": "gaudianello",
              "field2": "acqua ",
              "field3": "lt. 1,5 cassa x 6",
              "field4": "-effervescente naturale -frizzante",
              "description": "gaudianello acqua  lt. 1,5 cassa x 6 -effervescente naturale -frizzante",
              "grammage": 9000,
              "price": "1.50",
              "price_label": "€ 1,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Effervescente naturale",
                "Frizzante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 1.938911467504499,
                "left": 78.39000399636409,
                "width": 18.965986093044762,
                "height": 19.929919479945138
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Gaudianello_Fardello_x_6_1470387896_1529512871.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yh2ALMk_E0MMvre.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131718",
              "field1": "levissima",
              "field2": "acqua naturale",
              "field3": "lt. 2  ",
              "field4": "cassa x 6",
              "description": "levissima acqua naturale lt. 2   cassa x 6",
              "grammage": 12000,
              "price": "2.40",
              "price_label": "€ 2,40",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Acqua",
              "blueprint": {
                "top": 21.868830947449638,
                "left": 78.39000399636409,
                "width": 18.965986093044762,
                "height": 18.464483765890304
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/levissima_naturale_2_lt_x_6_1468226886.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/levissima_naturale_2_lt_1468226901.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_rMucouP_RyQemfO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133983",
              "field1": "raffo",
              "field2": "birra ",
              "field3": "cl. 33 x 3",
              "field4": "",
              "description": "raffo birra  cl. 33 x 3",
              "grammage": 990,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 40.33331471333994,
                "left": 78.39000399636409,
                "width": 18.965986093044762,
                "height": 19.05065936334394
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/5447_1529318883_1543603380_1595326939.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_EGbYUsT_c46NDBM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131700",
              "field1": "ichnusa",
              "field2": "birra non filtrata",
              "field3": "cl. 50",
              "field4": "",
              "description": "ichnusa birra non filtrata cl. 50",
              "grammage": 500,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 40.33331471333994,
                "left": 59.515191081055676,
                "width": 18.874812915308425,
                "height": 19.05065936334394
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ichnusa_birra_non_filtrata_1507535387_1526923226.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_BUSybuk_33sqPUT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133982",
              "field1": "san pellegrino ",
              "field2": "bibite",
              "field3": "lt. 1,25",
              "field4": "-aranciata classica -chinò -cocktail",
              "description": "san pellegrino  bibite lt. 1,25 -aranciata classica -chinò -cocktail",
              "grammage": 1250,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Aranciata classica",
                "Chinò",
                "Cocktail"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 40.33331471333994,
                "left": 40.640390409509784,
                "width": 18.87480067154589,
                "height": 19.05065936334394
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/San_Pellegrino_Chino_Lt_15_1443514571_1446733390.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/San_Pellegrino_aranciata_lt_125_1446216586_1467368343.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/san_pellegrino_cocktail_1450166834_1467901906_1512493856_1535451695.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_9Oltw81_sHkurmx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131705",
              "field1": "coca cola",
              "field2": "bipack",
              "field3": "lt. 1,35 x 2",
              "field4": "-classica -zero",
              "description": "coca cola bipack lt. 1,35 x 2 -classica -zero",
              "grammage": 2700,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classica",
                "Zero"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 59.38397407668387,
                "left": 40.640390409509784,
                "width": 37.658422043474175,
                "height": 38.785183151295406
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1042988_COCA_COLA_ZERO_BIPACK_1_5_1486727334_1492513881_1493282536_1_v5dukbi.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cocacolax2_1490861689_1492513814_1493282536_1493886339_1522243702.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yS3EMcB_VjwMBwT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179453",
              "field1": "tennent's",
              "field2": "super birra",
              "field3": "bottiglia cl. 35,5",
              "field4": "",
              "description": "tennent's super birra bottiglia cl. 35,5",
              "grammage": 355,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Birre",
              "blueprint": {
                "top": 59.38397407668387,
                "left": 78.29881245298395,
                "width": 19.148350814161233,
                "height": 38.785183151295406
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/494912_1554309343_1557473308_1557827706.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3VfTDGY_DTKlVW5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 16,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0016_z6ktpJh.jpg",
          "products": [
            {
              "item_id": "139380",
              "field1": "pomì",
              "field2": "passata di pomodoro",
              "field3": "gr. 700",
              "field4": "",
              "description": "pomì passata di pomodoro gr. 700",
              "grammage": 700,
              "price": "0.63",
              "price_label": "€ 0,63",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 16.144731409280862,
                "left": 2.80952280670135,
                "width": 18.790554035152336,
                "height": 24.235955809672323
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/41796_1521624359.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_7P8bfEH_0QeNIMD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131686",
              "field1": "la masseria",
              "field2": "olio extra vergine di oliva",
              "field3": "lt. 1",
              "field4": "",
              "description": "la masseria olio extra vergine di oliva lt. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 14.093121737562022,
                "left": 21.60007684185368,
                "width": 17.59131802144715,
                "height": 26.287565481391166
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/la_masseria_olio_evo_1_lt_1587546192.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_nr7knbW_JFEYMnC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166862",
              "field1": "mulino bianco ",
              "field2": "pancarrè 16 fette ",
              "field3": "gr. 285",
              "field4": "",
              "description": "mulino bianco  pancarrè 16 fette  gr. 285",
              "grammage": 285,
              "price": "0.50",
              "price_label": "€ 0,50",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 14.093121737562022,
                "left": 39.19139486330083,
                "width": 19.975924722409417,
                "height": 26.287565481391166
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/mulino_bianco_Pancarre_16_fette_1531132693_1542644150.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_SXrcLlM_aMTgFIc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140915",
              "field1": "mutti",
              "field2": "passata di pomodoro",
              "field3": "al basilico",
              "field4": "gr. 700",
              "description": "mutti passata di pomodoro al basilico gr. 700",
              "grammage": 700,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 1.7908932004929528,
                "left": 59.167319585710246,
                "width": 19.232612755257957,
                "height": 19.824792960599147
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/MUTTI_PASSATA_DI_POMODORO_AL_BASILICO_GR.700_1537265812.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_27qsFsZ_iZ5WVnX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "216410",
              "field1": "rossogargano",
              "field2": "pomodori pelati di puglia",
              "field3": "gr. 800",
              "field4": "",
              "description": "rossogargano pomodori pelati di puglia gr. 800",
              "grammage": 800,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 1.7908932004929528,
                "left": 78.3999323409682,
                "width": 19.88473317902928,
                "height": 19.824792960599147
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ROSSOGARGANO_Pomodoro_Pelato_800_gr_1594202324.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yESZcdV_g3jXhzw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131674",
              "field1": "mutti",
              "field2": "polpa in pezzi",
              "field3": "-di pomodoro gr. 400 x 3",
              "field4": "-di datterini gr. 300 x 3",
              "description": "mutti polpa in pezzi -di pomodoro gr. 400 x 3 -di datterini gr. 300 x 3",
              "grammage": 0,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pomodoro",
                "Datterini"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 21.6156861610921,
                "left": 59.707496390538786,
                "width": 38.57716912945869,
                "height": 19.058088856587904
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/70156142_Polpa_Datterini_3x300g_cod._55142_1559553008_1568130081_1596210894.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Mutti_Polpa_gr_400_x_3_1526027188_1541496468_1561365703_1596210896.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_LjMmeiD_X8dLjEB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141929",
              "field1": "barilla",
              "field2": "gr.400",
              "field3": "-sugo amatriciana -ragù bolognese",
              "field4": "-ragù contadino -ragù montanaro",
              "description": "barilla gr.400 -sugo amatriciana -ragù bolognese -ragù contadino -ragù montanaro",
              "grammage": 400,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Sugo amatriciana",
                "Ragù bolognese",
                "Ragù contadino",
                "Ragù montanaro"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Rossi",
              "blueprint": {
                "top": 40.67377501768001,
                "left": 40.56605681301717,
                "width": 19.14143957752163,
                "height": 18.65244504527113
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Amatriciana_400g_it_1543919652_1562144913_1570803803.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Ragu_bolognese_400g_it_1543919651_1562144914_1570803804.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_qKolj5y_7ANDAEr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185320",
              "field1": "de nigris",
              "field2": "aceto balsamico di modena igp",
              "field3": "ml. 250",
              "field4": "",
              "description": "de nigris aceto balsamico di modena igp ml. 250",
              "grammage": 250,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.67377501768001,
                "left": 59.707496390538815,
                "width": 18.606308170226118,
                "height": 18.65244504527113
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DENIGRIS_BALSAMICO_ML.250_1563527362.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_io5w7gH_VPUtA3d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "202066",
              "field1": "belvedere",
              "field2": "olio di semi di girasole",
              "field3": "lt. 1",
              "field4": "",
              "description": "belvedere olio di semi di girasole lt. 1",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Olio",
              "blueprint": {
                "top": 40.67377501768001,
                "left": 78.31380456076491,
                "width": 18.96125939734145,
                "height": 18.65244504527113
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BELVEDERE_girasole_2019__1576854927.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_b9LtVoT_KD5Czmc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166856",
              "field1": "mareblu ",
              "field2": "filetti di sgombro ",
              "field3": "gr. 90 ",
              "field4": "-olio d'oliva -piccanti -affumicati",
              "description": "mareblu  filetti di sgombro  gr. 90  -olio d'oliva -piccanti -affumicati",
              "grammage": 90,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Olio d'oliva",
                "Piccanti",
                "Affumicati"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.32622006295113,
                "left": 40.33812702116944,
                "width": 19.146848710766655,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Mareblu_Sgombri_Affumicati_90_g_1467984763_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Mareblu_Sgombri_Olio_90_g_1467984795_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Mareblu_Sgombri_Piccanti_90_g_1467984773_1542643792.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_9RcOll3_M9fG6Wu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131464",
              "field1": "mare aperto",
              "field2": "tonno all'olio di oliva ",
              "field3": "gr. 80 x 8",
              "field4": "",
              "description": "mare aperto tonno all'olio di oliva  gr. 80 x 8",
              "grammage": 640,
              "price": "4.89",
              "price_label": "€ 4,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.32622006295113,
                "left": 59.48497573193609,
                "width": 18.87116930725136,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/mare_aperto_tonno_olio_oliva_g._80_x_8_1503931904_1506332972.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_7nPPTKh_rrV5IOG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139554",
              "field1": "pam ",
              "field2": "tonno al naturale ",
              "field3": "gr. 80 x 3",
              "field4": "",
              "description": "pam  tonno al naturale  gr. 80 x 3",
              "grammage": 240,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.32622006295113,
                "left": 78.35614503918745,
                "width": 18.966668530586475,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000167_pam_tonno_naturale_g80x3_1560242130.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_QCisx0Q_IbKzroR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "230695",
              "field1": "daily bread",
              "field2": "pagnotta pan rustico",
              "field3": "ai cereali",
              "field4": "gr. 400",
              "description": "daily bread pagnotta pan rustico ai cereali gr. 400",
              "grammage": 400,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.12551246941746,
                "left": 78.35614503918745,
                "width": 18.966668530586475,
                "height": 19.81074620357229
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/DailyBread_pan_rustico_ai_cereali_1597136735_1597314754_1597314769.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mGgulFP_HeJFccz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134673",
              "field1": "gran pavesi",
              "field2": "i cracker",
              "field3": "gr. 280",
              "field4": "-pomodoro -olive",
              "description": "gran pavesi i cracker gr. 280 -pomodoro -olive",
              "grammage": 280,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pomodoro",
                "Olive"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 78.12551246941746,
                "left": 59.48497573193609,
                "width": 18.87116930725136,
                "height": 19.81074620357229
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/55621_1510309452.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/55622_1510309453.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_qS8sG5L_qwjBypj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134818",
              "field1": "rio mare",
              "field2": "filetti di tonno",
              "field3": "gr. 180",
              "field4": "-all'olio d'oliva -piccanti -al naturale",
              "description": "rio mare filetti di tonno gr. 180 -all'olio d'oliva -piccanti -al naturale",
              "grammage": 180,
              "price": "3.49",
              "price_label": "€ 3,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "All'olio d'oliva",
                "Piccanti",
                "Al naturale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.12551246941746,
                "left": 40.60839729143971,
                "width": 18.876578440496388,
                "height": 19.81074620357229
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/rio_mare_filetti_di_tonno_olio_oliva_1447870210.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_jiAMOPm_j7LGYLz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134822",
              "field1": "knorr ",
              "field2": "brodo granulare",
              "field3": "gr. 150",
              "field4": "-classico -verdure -pesce",
              "description": "knorr  brodo granulare gr. 150 -classico -verdure -pesce",
              "grammage": 150,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Verdure",
                "Pesce"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 81.60041594432093,
                "left": 21.016507263467627,
                "width": 19.59189002797208,
                "height": 16.335842728668815
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Classico_150_g_1570004948_1574097205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Pesce_150_g_1570004942_1574097206.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Vegetale_150_g_1570004941_1574097208.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_kxd5Sri_2v6e22C.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141879",
              "field1": "lipton ",
              "field2": "the yellow label",
              "field3": "25 filtri",
              "field4": "",
              "description": "lipton  the yellow label 25 filtri",
              "grammage": 0,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 83.33786768177265,
                "left": 2.77055945360187,
                "width": 18.245947809865758,
                "height": 14.598390991217077
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Lipton_yellow_label_1535124645_1539598111.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JJrUMAL_WuXkP3w.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "203231",
              "field1": "calvé ",
              "field2": "ketchup",
              "field3": "ml. 250",
              "field4": "-classico -piccante",
              "description": "calvé  ketchup ml. 250 -classico -piccante",
              "grammage": 250,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Piccante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 67.82042855715963,
                "left": 2.77055945360187,
                "width": 18.245947809865758,
                "height": 15.51743912461304
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Ketchup_Standard_2018_1523614892_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/KETCHUP_PICCANTE_2018_1523614893_1564505317_1571217261_1579106527.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_02nUfC6_rMdC94W.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139564",
              "field1": "calvè",
              "field2": "salsa squeeze",
              "field3": "ml. 250",
              "field4": "-barbecue -burger",
              "description": "calvè salsa squeeze ml. 250 -barbecue -burger",
              "grammage": 250,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Barbecue",
                "Burger"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 67.82042855715963,
                "left": 21.016507263467627,
                "width": 19.501799937881987,
                "height": 14.552188159362073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/calve_barbecue_250_ml_1554807655_1570803866.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/calve_burger_250_ml_1554807654_1570803867.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_yl5WrIO_AuPj5FC.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130207",
              "field1": "calvè",
              "field2": "maionese ",
              "field3": "vaso",
              "field4": "ml. 500",
              "description": "calvè maionese  vaso ml. 500",
              "grammage": 500,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 50.90543524934023,
                "left": 22.097588344548708,
                "width": 18.420718856800907,
                "height": 16.91499330781939
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/62003_Calve_Classica_maionese_500_ml_1429275510_1518105476.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_ynmGc76_gWiuSgH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239428",
              "field1": "knorr",
              "field2": "soffritto pronto",
              "field3": "-classico -per cipolla",
              "field4": "gr. 130",
              "description": "knorr soffritto pronto -classico -per cipolla gr. 130",
              "grammage": 130,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "Cipolla"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 50.90543524934023,
                "left": 2.6804693635117776,
                "width": 19.41711898103693,
                "height": 16.91499330781939
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Knorr_Soffritto_Cipolla_1603121860_1604336597_1604336632_1605715916.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Knorr_Soffritto_Classico_1603121861_1604336598_1604336633_1605715917.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_YxbZ4Sn_DybYncO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 17,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0017_3nKL2Ip.jpg",
          "products": [
            {
              "item_id": "170701",
              "field1": "la molisana",
              "field2": "pasta di semola ",
              "field3": "gr. 500",
              "field4": "varie trafile",
              "description": "la molisana pasta di semola  gr. 500 varie trafile",
              "grammage": 500,
              "price": "0.65",
              "price_label": "€ 0,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 1.833976833976834,
                "left": 1.8018018018018018,
                "width": 19.6873892513072,
                "height": 19.714221107047194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/la_molisana_PENNE_RIGATE_g._500_1500298857_1506085277.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/la_molisana_SPAGHETTO_QUADRATO_g._500_1500298858_1506085277.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_p3JFXhR_ZBFJ0rW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239429",
              "field1": "di bari",
              "field2": "pasta di semola trafilata al bronzo",
              "field3": "-tagliolini funghi -tagliolini limone -spaghetti al nero di seppia",
              "field4": "gr. 250",
              "description": "di bari pasta di semola trafilata al bronzo -tagliolini funghi -tagliolini limone -spaghetti al nero di seppia gr. 250",
              "grammage": 250,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tagliolini funghi",
                "Tagliolini limone",
                "Spaghetti al nero di seppia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 1.833976833976834,
                "left": 21.489191053109,
                "width": 19.14143957752163,
                "height": 19.714221107047194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TAGLIOLINA_AL_LIMONE_1606316195.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TAGLIOLINA_AI_FUNGHI_PORCINI_1606316196.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/SPAGHETTI_AL_NERO_DI_SEPPIA_1606316198.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_5fFXhHO_1wVHZRL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164178",
              "field1": "granoro",
              "field2": "lasagne all'uovo",
              "field3": "gr. 500",
              "field4": "",
              "description": "granoro lasagne all'uovo gr. 500",
              "grammage": 500,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 1.833976833976834,
                "left": 40.63063063063063,
                "width": 18.786488350406298,
                "height": 19.714221107047194
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/15404_1492176987.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_sHinZQo_FHsUlN3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134068",
              "field1": "eridania",
              "field2": "tropical zucchero di canna",
              "field3": "sacchetto kg. 1",
              "field4": "",
              "description": "eridania tropical zucchero di canna sacchetto kg. 1",
              "grammage": 0,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.548197941024025,
                "left": 40.63063063063063,
                "width": 18.786488350406298,
                "height": 18.992342599516512
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ERIDANIA_TROPICAL_ZUCCHERO_DI_CANNA_SACCHETTO_KG1_1532342371.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_voQyiZa_FqeToFo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134845",
              "field1": "gallo",
              "field2": "riso blond risotti",
              "field3": "kg. 1",
              "field4": "",
              "description": "gallo riso blond risotti kg. 1",
              "grammage": 0,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 21.548197941024025,
                "left": 21.66937123328918,
                "width": 18.96125939734145,
                "height": 18.992342599516512
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/GALLO_BlondRisotti-1Kg_febbraio_2013_1485508114_1519808674.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_tvlYAki_mhyyb59.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134036",
              "field1": "barilla emiliane",
              "field2": "nidi all'uovo",
              "field3": "gr. 250",
              "field4": "-tagliatelle -fettuccine -pappardelle",
              "description": "barilla emiliane nidi all'uovo gr. 250 -tagliatelle -fettuccine -pappardelle",
              "grammage": 250,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tagliatelle",
                "Fettuccine",
                "Pappardelle"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Pasta",
              "blueprint": {
                "top": 21.548197941024025,
                "left": 1.9819819819819793,
                "width": 19.6873892513072,
                "height": 18.992342599516512
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Fettuccine_250g_sx_1575304127_1581344447.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Pappardelle_ricce_250g_sx_1575304126_1581344448.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mt6J3TR_SlzG3sO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134825",
              "field1": "pam",
              "field2": "panna da cucina ",
              "field3": "ml. 200",
              "field4": "",
              "description": "pam panna da cucina  ml. 200",
              "grammage": 200,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.54054054054053,
                "left": 1.9819819819819793,
                "width": 19.6873892513072,
                "height": 18.94202033484642
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000286_pam_panna_cucina_m200_1532683073.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_T0qFu3x_zUyt47P.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134026",
              "field1": "chef ",
              "field2": "besciamella ",
              "field3": "ml. 200",
              "field4": "",
              "description": "chef  besciamella  ml. 200",
              "grammage": 200,
              "price": "0.75",
              "price_label": "€ 0,75",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.54054054054053,
                "left": 21.66937123328918,
                "width": 19.05134948743154,
                "height": 18.94202033484642
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/200__BESCIAMELLA_1486633120_1504514031.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Z5DCfch_zFTuH9D.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134846",
              "field1": "select",
              "field2": "legumi lessati",
              "field3": "gr. 360",
              "field4": "-fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "description": "select legumi lessati gr. 360 -fagioli borlotti -fagioli cannellini -fagioli tondini -ceci messico",
              "grammage": 360,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fagioli borlotti",
                "Fagioli Cannellini",
                "Fagioli tondini",
                "Ceci Messico"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 40.54054054054053,
                "left": 40.72072072072072,
                "width": 18.786488350406298,
                "height": 18.94202033484642
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Select_Fagioli_Borlotti_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Select_Fagioli_Cannellini_1521644296.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_mWagYwu_x0HfMxp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134041",
              "field1": "alisa ",
              "field2": "olive lattina",
              "field3": "-nere intere gr. 425",
              "field4": "-nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "description": "alisa  olive lattina -nere intere gr. 425 -nere snocciolate gr. 340 -verdi snocciolate gr. 340",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Nere intere",
                "Nere snocciolate",
                "Verdi snocciolate"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.48256087538696,
                "left": 40.72072072072072,
                "width": 18.786488350406298,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/alisa_olive_nere_intere_1498500062_1589539308.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/AlisaOliveVerdiDenocc_1533030532_1589539309.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_iP1pwf0_zNwdvIT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "185464",
              "field1": "saclà",
              "field2": "sottoli cuori di carciofo",
              "field3": "gr. 285",
              "field4": "",
              "description": "saclà sottoli cuori di carciofo gr. 285",
              "grammage": 285,
              "price": "3.19",
              "price_label": "€ 3,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.48256087538696,
                "left": 21.579281143199093,
                "width": 19.14143957752163,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/M_sottoli_cuori-di-carciofi_1593020411_1593160712.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Dz07SDp_qXpOoPM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130212",
              "field1": "saclà",
              "field2": "acetelli",
              "field3": "gr. 560",
              "field4": "-giardiniera -insalatina",
              "description": "saclà acetelli gr. 560 -giardiniera -insalatina",
              "grammage": 560,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Giardiniera",
                "Insalatina"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.48256087538696,
                "left": 1.711711711711714,
                "width": 19.86756943148738,
                "height": 18.799292406466318
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/sacla_acetelli_insalatina_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/M_acetelli_giardiniera_1593020356_1593160737.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_m62ydAF_nEBBpXK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130211",
              "field1": "pontI",
              "field2": "funghi alla pizzaiola",
              "field3": "gr. 280",
              "field4": "",
              "description": "pontI funghi alla pizzaiola gr. 280",
              "grammage": 280,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.28185328185327,
                "left": 1.711711711711714,
                "width": 19.86756943148738,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PONTI_FUNGHI_ALLA_PIZZAIOLA__GR.280_1595320859.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_37Is8vI_mj7L9a9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "132613",
              "field1": "del monte",
              "field2": "ananas sciroppate a fette ",
              "field3": "gr. 435",
              "field4": "",
              "description": "del monte ananas sciroppate a fette  gr. 435",
              "grammage": 435,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.28185328185327,
                "left": 21.579281143199093,
                "width": 19.05134948743154,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Ananas_Naturale_Fette_565g_1478792574_1503568368.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1Z7NRHv_jra7m0J.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "168481",
              "field1": "brioschi",
              "field2": "effervescente",
              "field3": "vaso gr. 250",
              "field4": "",
              "description": "brioschi effervescente vaso gr. 250",
              "grammage": 250,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.28185328185327,
                "left": 40.63063063063063,
                "width": 18.786488350406298,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Brioschi_Effervescente_250_gr_1543593021.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_6PZD19p_owRtM34.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131531",
              "field1": "ninfole",
              "field2": "caffè corallo",
              "field3": "gr. 250 x 4",
              "field4": "",
              "description": "ninfole caffè corallo gr. 250 x 4",
              "grammage": 0,
              "price": "5.99",
              "price_label": "€ 5,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 6.805019305019305,
                "left": 59.41441441441441,
                "width": 38.01801801801802,
                "height": 33.687258687258684
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/caffe_corallo_x4_1563791283.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_3PMd2A2_Ynfqxm8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134641",
              "field1": "bauli",
              "field2": "croissant farciti x 6",
              "field3": "gr. 300",
              "field4": "-cioccolato -crema -ciliegia -5 cereali latte",
              "description": "bauli croissant farciti x 6 gr. 300 -cioccolato -crema -ciliegia -5 cereali latte",
              "grammage": 300,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Cioccolato",
                "Crema",
                "Ciliegia",
                "5 cereali",
                "Latte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 40.49227799227799,
                "left": 59.41441441441441,
                "width": 18.738738738738736,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Croissant_Cioccolato_6pz_H_1580402014_1581099549_1581336137.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Croissant_Ciliegia_6pz_H_1582556601_1582898939_1585899220_1591943739.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_2Je4xxm_vlKB6kG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166865",
              "field1": "mulino bianco ",
              "field2": "nastrine classiche",
              "field3": "x 6 - gr. 240",
              "field4": "",
              "description": "mulino bianco  nastrine classiche x 6 - gr. 240",
              "grammage": 240,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 40.49227799227799,
                "left": 78.15315315315316,
                "width": 19.18918918918919,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Nastrine_6pz_sx_1524497459_1542644399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_RCurUpE_kdgCK3d.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134063",
              "field1": "vicenzovo",
              "field2": "savoiardi",
              "field3": "sacco gr. 400",
              "field4": "",
              "description": "vicenzovo savoiardi sacco gr. 400",
              "grammage": 400,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.31467181467181,
                "left": 78.15315315315316,
                "width": 19.18918918918919,
                "height": 18.918918918918916
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Vicenzovo_Savoiardi_400g_1464009468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_RhM72cg_vbeYqbP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134054",
              "field1": "pam",
              "field2": "plum cake con yogurt",
              "field3": "x 6",
              "field4": "gr. 198",
              "description": "pam plum cake con yogurt x 6 gr. 198",
              "grammage": 198,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 59.31467181467181,
                "left": 59.5045045045045,
                "width": 18.648648648648646,
                "height": 18.918918918918916
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3257740_PAM_PLUMCAKE_x_6_gr.198_1532351834.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_316hL9O_VNiH9UQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137380",
              "field1": "mulino bianco  ",
              "field2": "biscotti classici",
              "field3": "-tarallucci -macine -galletti gr. 350",
              "field4": "-spicchi di sole gr. 400",
              "description": "mulino bianco   biscotti classici -tarallucci -macine -galletti gr. 350 -spicchi di sole gr. 400",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Tarallucci",
                "Macine",
                "Galletti",
                "Spicchi di sole"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 59.5045045045045,
                "width": 18.648648648648646,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Macine_350g_sx2_1506522793.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Galletti_350g_sx2_1506522795.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Spicchi_di_sole_400g_sx2_1506522796.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_6vDkn6n_mudxNwp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134618",
              "field1": "oro saiwa",
              "field2": "biscotti classico",
              "field3": "kg. 1",
              "field4": "",
              "description": "oro saiwa biscotti classico kg. 1",
              "grammage": 0,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 78.15315315315316,
                "width": 19.18918918918919,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/oro_saiwa_1kg_1532680441.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_hjvaJu9_FZGutk7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 18,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0018_jljZpdG.jpg",
          "products": [
            {
              "item_id": "189899",
              "field1": "pam",
              "field2": "frollini con grano saraceno",
              "field3": "gr. 700",
              "field4": "",
              "description": "pam frollini con grano saraceno gr. 700",
              "grammage": 700,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 1.6891891891891893,
                "left": 2.5675675675675675,
                "width": 19.099099099099096,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3257738_pam_frollini_g700_grano_saraceno_1568625925.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_w8nDppu_Y5MyS2x.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140848",
              "field1": "mulino bianco",
              "field2": "fette biscottate dorate",
              "field3": "x 72",
              "field4": "gr. 630",
              "description": "mulino bianco fette biscottate dorate x 72 gr. 630",
              "grammage": 630,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 1.6891891891891893,
                "left": 21.666666666666668,
                "width": 18.82882882882883,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Fette_dorate_72_sx_1562581825_1564133614.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_OhJCePa_de5VMkx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140850",
              "field1": "fitness",
              "field2": "cereali integrali",
              "field3": "-fruits gr. 325 -chocolate gr. 375",
              "field4": "-dark chocolate gr. 375",
              "description": "fitness cereali integrali -fruits gr. 325 -chocolate gr. 375 -dark chocolate gr. 375",
              "grammage": 0,
              "price": "2.69",
              "price_label": "€ 2,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 1.6891891891891893,
                "left": 40.4954954954955,
                "width": 19.00900900900901,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/32513_1497627026_1575387242.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/nestle_fitness_cioccolato_375g_1495725156_1605721135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/nestle_fitness_cioccolato_fondente_375g_1495725157_1605721135.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Iv8BQMY_9h3heky.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "179446",
              "field1": "pam",
              "field2": "cereali anellini al miele gr. 375",
              "field3": "",
              "field4": "",
              "description": "pam cereali anellini al miele gr. 375",
              "grammage": 375,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Colazione",
              "blueprint": {
                "top": 1.6891891891891893,
                "left": 59.5045045045045,
                "width": 18.82882882882883,
                "height": 20.077220077220073
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pam_anellini_al_miele_375_gr_1597830690.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_lb2IYp6_UDDrYpj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "133979",
              "field1": "valfrutta",
              "field2": "succhi",
              "field3": "ml. 200 x 6",
              "field4": "-pera -pesca -albicocca",
              "description": "valfrutta succhi ml. 200 x 6 -pera -pesca -albicocca",
              "grammage": 1200,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Pera",
                "Pesca",
                "Albicocca"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 59.5045045045045,
                "width": 18.82882882882883,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/VF-cluster-albicoccaX6_10008_1548079549.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/VF-cluster-peraX6_10007_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/VF-cluster-pescaX6_10009_1548079550.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_I8pCxcE_xOaaeQD.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165937",
              "field1": "ambrosoli",
              "field2": "miele",
              "field3": "gr. 500",
              "field4": "",
              "description": "ambrosoli miele gr. 500",
              "grammage": 500,
              "price": "4.49",
              "price_label": "€ 4,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 40.585585585585584,
                "width": 18.918918918918916,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ambrosoli_miele_1543316770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_0yebZJW_qW8oCp7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "170704",
              "field1": "rigoni",
              "field2": "nocciolata bio classica",
              "field3": "gr. 270",
              "field4": "",
              "description": "rigoni nocciolata bio classica gr. 270",
              "grammage": 270,
              "price": "3.29",
              "price_label": "€ 3,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 21.576576576576574,
                "width": 19.00900900900901,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/484801_ITA_Nocc_classica_2020_rev1-e1592912812381_1599062950_1600183_xqb8BZ8.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_OZTq4QS_XOum1Lh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131545",
              "field1": "zuegg ",
              "field2": "confetture 100% da frutta",
              "field3": "gr. 250",
              "field4": "vari gusti",
              "description": "zuegg  confetture 100% da frutta gr. 250 vari gusti",
              "grammage": 250,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 2.747747747747747,
                "width": 18.82882882882883,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Zuegg_Ciliegie_1467987669_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Zuegg_Fragole_1467987661_1535995531.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Zuegg_Frutti-bosco_1467987654_1535995532.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_L9WlKDY_8bzvFwo.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140942",
              "field1": "santal",
              "field2": "succhi brik",
              "field3": "lt. 1",
              "field4": "-classici -plus vari gusti",
              "description": "santal succhi brik lt. 1 -classici -plus vari gusti",
              "grammage": 0,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classici",
                "Plus"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Succhi",
              "blueprint": {
                "top": 40.58880308880309,
                "left": 2.747747747747747,
                "width": 18.82882882882883,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/santal_plus_pesca_mango_1587546032.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/santal_succo_pesca_1587546033.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/santal_succo_plus_ananas_cocco_1587546034.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_8rd5q3L_JuSuuY9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134630",
              "field1": "parmalat ",
              "field2": "latte del benessere uht",
              "field3": "lt. 1",
              "field4": "-calcium plus -omega 3",
              "description": "parmalat  latte del benessere uht lt. 1 -calcium plus -omega 3",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Calcium plus",
                "Omega 3"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 40.58880308880309,
                "left": 21.576576576576574,
                "width": 18.918918918918916,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1038121_LATTE_UHT_PARMALAT_1L_CALCIUM_PLUS_1523439517.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/1038126_LATTE_UHT_PARMALAT_1L_OMEGA3_1523439521.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_b3PJuYx_3RR7Qx5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134075",
              "field1": "trevalli ",
              "field2": "latte uht edge",
              "field3": "parzialmente scremato 100% italiano",
              "field4": "lt. 1",
              "description": "trevalli  latte uht edge parzialmente scremato 100% italiano lt. 1",
              "grammage": null,
              "price": "0.65",
              "price_label": "€ 0,65",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 40.58880308880309,
                "left": 40.4954954954955,
                "width": 19.00900900900901,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TRE_VALLI_Latte_100_Italiano_PS__Edge_lt.1_1532342298.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_QkL9F7W_T1Xn6Qu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "215557",
              "field1": "zymil",
              "field2": "benefit latte uht",
              "field3": "lt. 1",
              "field4": "-calcio -fibre -vitamina B12 e D",
              "description": "zymil benefit latte uht lt. 1 -calcio -fibre -vitamina B12 e D",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Calcio",
                "Fibre",
                "Vitamine B12 E D"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Self Service",
              "subcategory": "Latte",
              "blueprint": {
                "top": 40.58880308880309,
                "left": 59.5045045045045,
                "width": 18.648648648648646,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/principale_8002580003671_1587740610_1592207096_1592840883_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/principale_8002580003695_1587740611_1592207097_1592840884_1593016203.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ZYMIL_BENEFIT_VITAMINE_FRONT_1599240553.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_qYCVPXf_RcW6EHI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "180759",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "capsule x 16",
              "field4": "vari tipi",
              "description": "nescafè dolce gusto capsule x 16 vari tipi",
              "grammage": 0,
              "price": "4.59",
              "price_label": "€ 4,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 59.5045045045045,
                "width": 18.648648648648646,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/NESCAFE_DOLCE_GUSTO_NAPOLI_1559122141.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/NESCAFE_DOLCE_GUSTO_ROMA_1559122142.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_IDYxiTR_TdYiRBj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130252",
              "field1": "lavazza",
              "field2": "caffè crema e gusto espresso",
              "field3": "gr. 250",
              "field4": "",
              "description": "lavazza caffè crema e gusto espresso gr. 250",
              "grammage": 250,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 40.4954954954955,
                "width": 19.00900900900901,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Lavazza_espresso_classico_250_gr_1504802586.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_pSQfCxh_0JFRBsJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "130255",
              "field1": "lavazza",
              "field2": "caffè crema e gusto classico",
              "field3": "gr. 250 x 3",
              "field4": "",
              "description": "lavazza caffè crema e gusto classico gr. 250 x 3",
              "grammage": 750,
              "price": "5.49",
              "price_label": "€ 5,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Dispensa",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 21.486486486486484,
                "width": 19.00900900900901,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Lavazza_crema_e_gusto_classico_3_x_250_1521196954.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_HWzkWoo_NE4PT5b.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137389",
              "field1": "céréal",
              "field2": "soia drink calcio",
              "field3": "lt. 1",
              "field4": "",
              "description": "céréal soia drink calcio lt. 1",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Bevande",
              "subcategory": "Bibite",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 2.4774774774774775,
                "width": 19.00900900900901,
                "height": 18.82239382239382
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/CEREAL_SOIA_DRINK_CALCIO_1__LT._1505837035_1565691205.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_hAbZOAq_JTQXaX4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "166886",
              "field1": "fida ",
              "field2": "caramelle bonelle ",
              "field3": "vari gusti",
              "field4": "busta gr. 150/175",
              "description": "fida  caramelle bonelle  vari gusti busta gr. 150/175",
              "grammage": 0,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 2.4774774774774775,
                "width": 19.00900900900901,
                "height": 19.44980694980695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/FIDA_CARAMELLE_BUSTA_GR.200_gruppo_1573481687.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_cyEdetO_LVNYPmg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139537",
              "field1": "pam  ",
              "field2": "wafer",
              "field3": "gr. 175",
              "field4": "crema -latte -cacao -nocciola",
              "description": "pam   wafer gr. 175 crema -latte -cacao -nocciola",
              "grammage": 175,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Crema",
                "Latte",
                "Cacao",
                "Nocciola"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 21.486486486486484,
                "width": 19.099099099099096,
                "height": 19.44980694980695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000314_pam_wafer_g175_cacao_1561458671.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000315_pam_wafer_g175_nocciola_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000316_pam_wafer_g175_latte_1561458672.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_xwrTu1r_bSTld9Z.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "141904",
              "field1": "novi",
              "field2": "tavoletta di cioccolato le specialità",
              "field3": "vari gusti gr. 100 ",
              "field4": "",
              "description": "novi tavoletta di cioccolato le specialità vari gusti gr. 100 ",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Dolci",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 40.585585585585584,
                "width": 18.918918918918916,
                "height": 19.44980694980695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/tavoletta-fondentenero_1576505514.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/noisette_1576505514.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/novi_bianco_1576505515.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_feSGosk_xblSXIx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134074",
              "field1": "nescafè",
              "field2": "dolce gusto",
              "field3": "macchina con 32 caps omaggio ",
              "field4": "",
              "description": "nescafè dolce gusto macchina con 32 caps omaggio ",
              "grammage": null,
              "price": "49.90",
              "price_label": "€ 49,90",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Piccoli elettrodomestici",
              "subcategory": "Preparazione cibo",
              "blueprint": {
                "top": 78.23359073359073,
                "left": 59.5045045045045,
                "width": 18.82882882882883,
                "height": 19.44980694980695
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/NESCAFE_MACCHINA_DOLCE_GUSTO_KRUBS_1552665915.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_PBn85q8_GRDVn1u.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "217341",
              "field1": "patatine",
              "field2": "pringles",
              "field3": "-original -paprika -ketchup",
              "field4": "gr. 175",
              "description": "patatine pringles -original -paprika -ketchup gr. 175",
              "grammage": 175,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "Paprika",
                "Ketchup"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 1.7374517374517375,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 19.93243243243243
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/FLAT_HPR_1589464557_1590569567_1590734737_1592318342_1593790323_1595265536.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/FLAT_ORG_1589464560_1590569568_1590734738_1592318343_1593790324_1595265537.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_n9QtnJM_cj1i9YW.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139549",
              "field1": "pai",
              "field2": "le patatine",
              "field3": "gr. 300",
              "field4": "",
              "description": "pai le patatine gr. 300",
              "grammage": 300,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 21.669884169884167,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 15.106177606177607
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/pai_patatine_senza_glutine_e_c496148348_1506524401_1512034015.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_RZ1x7OY_nwoRNvR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165924",
              "field1": "tuc ",
              "field2": "crisp",
              "field3": "gr. 100",
              "field4": "-original -erbe mediterranee -paprika -pepe nero e sale",
              "description": "tuc  crisp gr. 100 -original -erbe mediterranee -paprika -pepe nero e sale",
              "grammage": 100,
              "price": "1.29",
              "price_label": "€ 1,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Original",
                "erbe mediterranee",
                "paprika",
                "pepe nero e sale"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 36.77606177606177,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 15.00965250965251
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TUC_CRIPS_erbe_mediterranee_1473240871_1504628582_1542027770.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TUC_CRIPS_paprika_1473240848_1504628582_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TUC_CRIPS_sale_marino_1473240884_1504628583_1542027771.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_6q83bUa_NGgcX7p.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "182013",
              "field1": "scotti ",
              "field2": "riso snack",
              "field3": "gr. 60",
              "field4": "-paprika -erbe fini",
              "description": "scotti  riso snack gr. 60 -paprika -erbe fini",
              "grammage": 60,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "paprika",
                "Erbe fini"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 51.785714285714285,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 15.2992277992278
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/scotti_riso_snack_g60_erbe_fini_1560250402.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_0x1hWtu_jRuC6Gp.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239678",
              "field1": "pam",
              "field2": "arachidi tostate e salate sacchetto",
              "field3": "gr. 300",
              "field4": "",
              "description": "pam arachidi tostate e salate sacchetto gr. 300",
              "grammage": 300,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack Salati",
              "blueprint": {
                "top": 67.08494208494209,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 15.00965250965251
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8004263662403_T70_1606484877.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_IQByUD4_oyRDdcH.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131647",
              "field1": "fiore di puglia",
              "field2": "taralli",
              "field3": "gr. 500",
              "field4": "-classico -mediterraneo -finocchio",
              "description": "fiore di puglia taralli gr. 500 -classico -mediterraneo -finocchio",
              "grammage": 500,
              "price": "1.69",
              "price_label": "€ 1,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "mediterraneo",
                "Finocchio"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Alimentari",
              "subcategory": "Snack salati",
              "blueprint": {
                "top": 82.09459459459458,
                "left": 78.37837837837837,
                "width": 20.0,
                "height": 16.167953667953668
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/fiore_di_puglia_Taralli__g500_finocchio__1531124850.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/fiore_di_puglia_Taralli__g500__mediterraneo__1531124848_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/fiore_di_puglia_Taralli__g500_classici__1531124849_1538210579.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Cd8PRYO_RggAap2.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 19,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0019_M3VVVMt.jpg",
          "products": [
            {
              "item_id": "137464",
              "field1": "regina",
              "field2": "maxi tovaglioli decorati",
              "field3": "x 250",
              "field4": "",
              "description": "regina maxi tovaglioli decorati x 250",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 12.693050193050194,
                "left": 2.927927927927928,
                "width": 26.75675675675675,
                "height": 27.99227799227799
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/59725_ReginaTovaglioliMaxi_1543933007_1552564458_1555346827_15626701_sGSkLaZ.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_WrabAnq_3kGMSAF.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131596",
              "field1": "aristea ",
              "field2": "piatti rigidi",
              "field3": "kg. 1 ",
              "field4": "-fondi -piani ",
              "description": "aristea  piatti rigidi kg. 1  -fondi -piani ",
              "grammage": 0,
              "price": "2.59",
              "price_label": "€ 2,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Fondi",
                "Piani"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 12.693050193050194,
                "left": 29.684684684684683,
                "width": 29.819819819819816,
                "height": 27.99227799227799
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Aristea_Piatti_Extra-Rigidi_Piani_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Aristea_Piatti_Extra-Rigidi_Fondo_1_kg_1531132425.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_JrmJbT7_2Ba0yUK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239430",
              "field1": "svelto",
              "field2": "piatti ",
              "field3": "-antibatterico -limone verde -aceto -zenzero e limone",
              "field4": "lt. 1",
              "description": "svelto piatti  -antibatterico -limone verde -aceto -zenzero e limone lt. 1",
              "grammage": 0,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Antibatterico",
                "Limone verde",
                "Aceto",
                "Zenzero e limone"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Stoviglie",
              "blueprint": {
                "top": 10.183397683397683,
                "left": 59.5045045045045,
                "width": 37.65765765765766,
                "height": 30.5019305019305
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Svelto_LIMONE_VERDE_1496918743_1499071488_1512486297_1542632483_1605716460.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/svelto_ACETO_1l_1496918742_1499071488_1512486297_1532967204_15427153_Pf5iU2q.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_icO91x7_0rCUMHB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "211400",
              "field1": "vernel",
              "field2": "ammorbidente concentrato",
              "field3": "28 lavaggi ml. 700",
              "field4": "vari tipi",
              "description": "vernel ammorbidente concentrato 28 lavaggi ml. 700 vari tipi",
              "grammage": 700,
              "price": "1.39",
              "price_label": "€ 1,39",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 40.68532818532818,
                "left": 78.33333333333333,
                "width": 18.82882882882883,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/61934_VernelBluOxygen_1565252093_1566381930_1569256625_1582543571_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/61935_VernelLavanda_1565252095_1566381930_1569256626_1582543572_1587715603.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_h6yuUbF_kbM0Yn7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "183607",
              "field1": "pam",
              "field2": "lavatrice liquido 30 lavaggi",
              "field3": "lt. 2",
              "field4": "-aloe vera -fresco profumo",
              "description": "pam lavatrice liquido 30 lavaggi lt. 2 -aloe vera -fresco profumo",
              "grammage": 2000,
              "price": "2.79",
              "price_label": "€ 2,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Aloe vera",
                "Fresco Profumo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 40.68532818532818,
                "left": 59.41441441441441,
                "width": 18.918918918918916,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260429_PAM_LAVATR.LIQ.30lav.ALOE_VERA_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260430_PAM_LAVATR.LIQ.30lav.FRESCO_1561459057.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_UjrjFbY_D7aD5OX.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134851",
              "field1": "pam ",
              "field2": "pellicola trasparente ",
              "field3": "50 metri",
              "field4": "",
              "description": "pam  pellicola trasparente  50 metri",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.68532818532818,
                "left": 40.67567567567567,
                "width": 18.738738738738736,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000107_pam_pellicola_trasparente_50mt_1532683313.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_PpH7p6V_S6FtLlJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137471",
              "field1": "pam",
              "field2": "alluminio",
              "field3": "16 metri",
              "field4": "",
              "description": "pam alluminio 16 metri",
              "grammage": 0,
              "price": "1.09",
              "price_label": "€ 1,09",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.68532818532818,
                "left": 21.666666666666668,
                "width": 19.00900900900901,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/4000108_PAM_ALLUMINIO_16_METRI_1533288333.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_QYnJqnB_IVH0pNK.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "235658",
              "field1": "cuki",
              "field2": "carta per fritti",
              "field3": "20 fogli",
              "field4": "32x33",
              "description": "cuki carta per fritti 20 fogli 32x33",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 40.68532818532818,
                "left": 2.8378378378378373,
                "width": 18.82882882882883,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/8003980210010_1564130470_1600677091_1603294038.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_c6psihs_1a7Z4eM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131607",
              "field1": "cuki",
              "field2": "2 vaschette alluminio da 12 porzioni",
              "field3": "",
              "field4": "",
              "description": "cuki 2 vaschette alluminio da 12 porzioni",
              "grammage": 0,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 2.8378378378378373,
                "width": 18.82882882882883,
                "height": 18.53281853281853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Cuki_Vaschetta_Senza_Coperchio_12_porzioni_1504099229.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1M8x1QO_1wujxU5.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134052",
              "field1": "bulky soft ",
              "field2": "bobinotto asciugatutto ",
              "field3": "500 strappi",
              "field4": "",
              "description": "bulky soft  bobinotto asciugatutto  500 strappi",
              "grammage": null,
              "price": "2.29",
              "price_label": "€ 2,29",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Superfici",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 21.666666666666668,
                "width": 19.27927927927928,
                "height": 18.53281853281853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BulkySoft_bobinotto_500_strappi_1532351892.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_VX9Gjyx_iGy0dE0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "208442",
              "field1": "pam eco",
              "field2": "tovaglioli bianchi",
              "field3": "cm. 33x33 2 veli",
              "field4": "x50",
              "description": "pam eco tovaglioli bianchi cm. 33x33 2 veli x50",
              "grammage": 0,
              "price": "0.59",
              "price_label": "€ 0,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 40.945945945945944,
                "width": 18.468468468468465,
                "height": 18.53281853281853
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3261886_PAM_ECO_TOVAGLIOLI_CM.33X33_2_VELI_x50_PZ_1584602501.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_OSkQ7YL_R9RKlzT.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "167090",
              "field1": "ace",
              "field2": "candeggina",
              "field3": "lt. 5",
              "field4": "",
              "description": "ace candeggina lt. 5",
              "grammage": 5000,
              "price": "2.99",
              "price_label": "€ 2,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Bucato",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 59.41441441441441,
                "width": 18.918918918918916,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ace-classica-5-lt_1558948335.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_EjTORZp_sNUAZyr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206606",
              "field1": "ace",
              "field2": "sgrassatore senza candeggina",
              "field3": "spray ml. 500",
              "field4": "-universale -cucina -igienizzante",
              "description": "ace sgrassatore senza candeggina spray ml. 500 -universale -cucina -igienizzante",
              "grammage": 500,
              "price": "1.49",
              "price_label": "€ 1,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Universale",
                "Cucina",
                "Igienizzante"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Casa",
              "subcategory": "Superfici",
              "blueprint": {
                "top": 59.41119691119692,
                "left": 78.33333333333333,
                "width": 18.738738738738736,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ace-spray-sgrassatore-universale-senza-candeggina-fresco-profumo-500_q3b7eAn.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ACE_SPRAY_SGRASSATORE_CUCINA_500ML_1580406347_1582301398.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ACE_SPRAY_SGRASSATORE_IGIENIZZANTE_500ML_1580406349_1582301399.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_reALa1e_FxwUxyg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165949",
              "field1": "duracell",
              "field2": "plus power",
              "field3": "x 4",
              "field4": "-stilo -ministilo",
              "description": "duracell plus power x 4 -stilo -ministilo",
              "grammage": 0,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Stilo",
                "Ministilo"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 78.13706563706563,
                "left": 78.33333333333333,
                "width": 18.738738738738736,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/duracell_1543317061.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_AGdXlFk_nHkUhCQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165933",
              "field1": "linea fresh",
              "field2": "candele profumate",
              "field3": "gr. 120",
              "field4": "assortite",
              "description": "linea fresh candele profumate gr. 120 assortite",
              "grammage": null,
              "price": "1.79",
              "price_label": "€ 1,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.13706563706563,
                "left": 59.5045045045045,
                "width": 18.82882882882883,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/linea_fresh_Candela_Profumata_1542047415.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_eDFCTx0_TILWqV8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "139582",
              "field1": "cuki vaschette in alluminio ",
              "field2": "•2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI ",
              "field3": "•3 VASCHETTE ALLUMINIO DA 5 PORZIONI",
              "field4": "•4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "description": "cuki vaschette in alluminio  •2 VASCHETTE ALLUMINIO DA 6 PORZIONI •2 VASCHETTE ALLUMINIO DA 8 PORZIONI  •3 VASCHETTE ALLUMINIO DA 5 PORZIONI •4 VASCHETTE ALLUMINIO DA 4 PORZIONI",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "2 VASCHETTE ALLUMINIO DA 6 PORZIONI",
                "2 VASCHETTE ALLUMINIO DA 8 PORZIONI ",
                "3 VASCHETTE ALLUMINIO DA 5 PORZIONI",
                "4 VASCHETTE ALLUMINIO DA 4 PORZIONI"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.13706563706563,
                "left": 40.67567567567567,
                "width": 18.82882882882883,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Vaschetta_CUKI_RS98_-_8_porzioni_Giugiaro_x2_1444907247.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_DcdQBA4_PAxYlaU.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "165928",
              "field1": "tenderly",
              "field2": "duo prestige tovaglioli rossi 38x38",
              "field3": "2 veli x 30",
              "field4": "",
              "description": "tenderly duo prestige tovaglioli rossi 38x38 2 veli x 30",
              "grammage": 0,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Casa e Cucina",
              "subcategory": "Altro",
              "blueprint": {
                "top": 78.13706563706563,
                "left": 21.666666666666668,
                "width": 19.00900900900901,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/tenderly_duo_Prestige_rosso_1542047453.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_8zHtRzL_SBNKfJG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "131598",
              "field1": "aristea ",
              "field2": "bicchieri bianchi",
              "field3": "cc. 200",
              "field4": "x 100",
              "description": "aristea  bicchieri bianchi cc. 200 x 100",
              "grammage": 0,
              "price": "0.89",
              "price_label": "€ 0,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "No Food",
              "subcategory": "Home",
              "blueprint": {
                "top": 78.13706563706563,
                "left": 3.0180180180180183,
                "width": 18.648648648648646,
                "height": 19.980694980694977
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Aristea_100_bicchieri_2_colonne_200_cc.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_uXKd6Y7_k66BAJJ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 20,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/7129_Pam_Bassa_page-0020_arbMQcn.jpg",
          "products": [
            {
              "item_id": "132571",
              "field1": "tenderly",
              "field2": "carta igienica kilometrica",
              "field3": "x 12 maxi rotoli",
              "field4": "",
              "description": "tenderly carta igienica kilometrica x 12 maxi rotoli",
              "grammage": null,
              "price": "3.99",
              "price_label": "€ 3,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 6.6119691119691115,
                "left": 2.8378378378378373,
                "width": 37.65765765765766,
                "height": 34.07335907335907
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/TENDERLY_CARTA_IG.KILOMETR.x12_1532093467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_C4UIVnf_KWG7DEe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "134875",
              "field1": "pam arkalia ",
              "field2": "maxi dischetti struccanti ",
              "field3": "x 50",
              "field4": "",
              "description": "pam arkalia  maxi dischetti struccanti  x 50",
              "grammage": null,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Viso",
              "blueprint": {
                "top": 3.1370656370656373,
                "left": 40.4954954954955,
                "width": 19.27927927927928,
                "height": 18.629343629343627
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PAM_ARKALIA_MAXI_DISCHETTI_STRUCCANTI_X_50_1535449256.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_zl1ovvf_vcQ7sje.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "140951",
              "field1": "bulky soft ",
              "field2": "carta igienica mia profumata",
              "field3": "3 veli",
              "field4": "x 4 maxi rotoli",
              "description": "bulky soft  carta igienica mia profumata 3 veli x 4 maxi rotoli",
              "grammage": null,
              "price": "1.59",
              "price_label": "€ 1,59",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 40.4954954954955,
                "width": 19.27927927927928,
                "height": 18.629343629343627
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/BulkySoft_carta_igienica_3v_prof.x4_maxi_1537364928.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_n2ZoNVs_yrLOYva.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "239431",
              "field1": "nivea",
              "field2": "bagno creme",
              "field3": "-care -smooth -soft",
              "field4": "ml. 650",
              "description": "nivea bagno creme -care -smooth -soft ml. 650",
              "grammage": 650,
              "price": "2.49",
              "price_label": "€ 2,49",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Care",
                "Smooth",
                "Soft"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 21.766409266409266,
                "left": 59.77477477477478,
                "width": 18.558558558558556,
                "height": 18.629343629343627
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/80968_22922_1605716634.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/80969_22918_1605716635.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_1IYiDiT_vuNqRtj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137439",
              "field1": "pam",
              "field2": "arkalia sapone",
              "field3": "ml. 300",
              "field4": "-argan -latte e miele",
              "description": "pam arkalia sapone ml. 300 -argan -latte e miele",
              "grammage": 300,
              "price": "0.99",
              "price_label": "€ 0,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Argan",
                "Latte e miele"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 3.0405405405405403,
                "left": 59.77477477477478,
                "width": 18.558558558558556,
                "height": 18.72586872586872
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/PAM_ARKALIA_SAPONE_M300_tutti_1533307340.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_Celim5G_egygIjj.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "137436",
              "field1": "mil mil",
              "field2": "sapone liquido busta ",
              "field3": "lt. 2 ",
              "field4": "-morbidezza naturale -cocco e vaniglia",
              "description": "mil mil sapone liquido busta  lt. 2  -morbidezza naturale -cocco e vaniglia",
              "grammage": 2000,
              "price": "2.19",
              "price_label": "€ 2,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Morbidezza naturale",
                "Cocco e vaniglia"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 3.0405405405405403,
                "left": 78.33333333333333,
                "width": 18.963963963963963,
                "height": 37.35521235521236
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/mil_mil_sapone_liquido_ricarica_classico_cocco_2_lt_1506332984_1506411554.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4y5WKOG_WbrzDHr.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "206631",
              "field1": "antica erboristeria",
              "field2": "shampoo ",
              "field3": "-classico -2in1",
              "field4": "vari trattamenti ml. 225/250",
              "description": "antica erboristeria shampoo  -classico -2in1 vari trattamenti ml. 225/250",
              "grammage": 0,
              "price": "1.19",
              "price_label": "€ 1,19",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Classico",
                "2 in 1"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Capelli",
              "blueprint": {
                "top": 40.39575289575289,
                "left": 78.33333333333333,
                "width": 18.963963963963963,
                "height": 19.884169884169882
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_CAMOMILLA_1582305798_1582827538.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/ANTICA_ERBORISTERIA_SHAMPOO_ML.250_ORTICA_1582305797_1582827539.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/antica_erboristeria_shampo_e_balsamo_bacche_acai_1582556654_1588926583.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/antica_erboristeria_shampo_e_balsamo_frutto_passione_1582556655_1588926584.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_DB2rdbQ_d3eMINP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "164144",
              "field1": "colgate",
              "field2": "dentifricio family action",
              "field3": "ml. 75",
              "field4": "",
              "description": "colgate dentifricio family action ml. 75",
              "grammage": 75,
              "price": "0.79",
              "price_label": "€ 0,79",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 40.39575289575289,
                "left": 59.549549549549546,
                "width": 18.783783783783782,
                "height": 19.884169884169882
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/FOTO_DENTIFRICIO_FAMILY_ACTION_75_ml_1550239870.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_4i6o8OX_sauMINS.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162590",
              "field1": "pasta del capitano",
              "field2": "spazzolino family",
              "field3": "",
              "field4": "-medio -forte",
              "description": "pasta del capitano spazzolino family -medio -forte",
              "grammage": 0,
              "price": "0.69",
              "price_label": "€ 0,69",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Medio",
                "Forte"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Orale",
              "blueprint": {
                "top": 40.39575289575289,
                "left": 40.4954954954955,
                "width": 19.054054054054053,
                "height": 19.884169884169882
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/36080_1553869757_1572963996_1575386102.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_xJryfHc_j1ATQ3c.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "162589",
              "field1": "dove",
              "field2": "deo",
              "field3": "spray vari tipi ml. 150",
              "field4": "",
              "description": "dove deo spray vari tipi ml. 150",
              "grammage": 150,
              "price": "1.89",
              "price_label": "€ 1,89",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Corpo",
              "blueprint": {
                "top": 40.39575289575289,
                "left": 21.531531531531535,
                "width": 18.963963963963963,
                "height": 19.884169884169882
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Dove_deodorante_original_1530607792_1539339984.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/Dove_deo_spray_ml.150_Mela_1573487542.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_HaLajvl_XM1OcHc.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            },
            {
              "item_id": "186597",
              "field1": "dermogella",
              "field2": "-intimo ml. 250",
              "field3": "-intima lenitiva ml. 200",
              "field4": "-intima attiva ml. 200",
              "description": "dermogella -intimo ml. 250 -intima lenitiva ml. 200 -intima attiva ml. 200",
              "grammage": 0,
              "price": "1.99",
              "price_label": "€ 1,99",
              "equivalence": 1,
              "quantity_step": 1,
              "grocery_label": "pz.",
              "varieties": [
                "Intimo",
                "Intima lenitiva",
                "Intima attiva"
              ],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": false,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": "Igiene Persona",
              "subcategory": "Intima",
              "blueprint": {
                "top": 40.39575289575289,
                "left": 2.56756756756757,
                "width": 18.963963963963963,
                "height": 19.884169884169882
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260763_1564738467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260768_1564738467.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/3260769_1564738468.jpg",
                  "cropped": false
                },
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/products/cropped_image_lq9io8P_UiXLAoa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                }
              ]
            }
          ]
        },
        {
          "number": 21,
          "image_file": "https://interattivo.s3.amazonaws.com/zJhLivpIOk/pages/Fine-PAM-ok_O6MC8a1.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.pam;
}

export const serverResponse = lefletSwitch(); 